import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChartLine,
    faBuilding,
    faCheckCircle,
    faExclamationTriangle, faPaperPlane,
    faFileAlt, faCalendarCheck,
    faCalendarAlt, faTimes,
    faCog, faTimesCircle, faCircleCheck, faCircleXmark, faClipboardList
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { db, storage } from '../../../firebase.init';
import { collection, getDocs, query, where, updateDoc, doc, setDoc, addDoc, deleteDoc, orderBy, limit, getDocsFromServer, collectionGroup, onSnapshot } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import dayjs from "dayjs";
import greenDoor from '../../Assets/Fire-Checked-green.png'
import redDoor from '../../Assets/Fire-Checked-red.png'
import yellowDoor from '../../Assets/Fire-Checked-yellow.png'
import greyDoor from '../../Assets/Fire-Checked-grey.png'
import defaultImage from '../../Assets/default.png'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { auth } from '../../../firebase.init';
import logo from '../../Assets/logo.png'
import './Dashboard.css'
import { ToastContainer, toast } from 'react-toastify';
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes } from "firebase/storage";
import Modal from 'react-modal';
import { Modal as BootstrapModal, Container, Card, Tabs, Tab, Button, Form, Col, Row, ProgressBar } from 'react-bootstrap';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { format, formatDate, set } from 'date-fns';
// import { scroller, Element, animateScroll } from 'react-scroll';
import ClipLoader from "react-spinners/ClipLoader";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import { Spinner } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
// import 'flatpickr/dist/flatpickr.min.css';
import "flatpickr/dist/themes/material_red.css";
import * as XLSX from "xlsx";
import { parse } from 'date-fns';
import ContactModal from '../../ContactModal/ContactModal';
import { useUserRole } from '../../../hooks/useUserRole';
import InspectionModal from './InspectionModal';

const NewBuilding = () => {
    const [user, loadingAuth] = useAuthState(auth);

    const navigate = useNavigate();
    const location = useLocation();
    const [stats, setStats] = useState([]);
    const [recentActivity, setRecentActivity] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingData, setLoadingData] = useState(true);

    const [data, setData] = useState([]);
    const [signOffCount, setSignOffCount] = useState(0);
    const [buildingsWithPreviousReports, setBuildingsWithPreviousReports] = useState([]);
    const [nestedReports, setNestedReports] = useState({});
    const [reportInfos, setReportInfos] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBuildings, setSelectedBuildings] = useState([]);
    const [selectedInspector, setSelectedInspector] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);

    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [selectedBuildings1, setSelectedBuildings1] = useState([]);
    const [selectedBuildingsDoor, setSelectedBuildingsDoor] = useState([]);
    const [selectedInspector1, setSelectedInspector1] = useState(null);
    const [currentStep1, setCurrentStep1] = useState(1);
    const [inspectionDate, setInspectionDate] = useState('');

    const [emails, setEmails] = useState([]);
    const [doorFilters, setDoorFilters] = useState({});
    const [resiDoorFilters, setResiDoorFilters] = useState({});
    const [selectedData, setSelectedData] = useState({});

    const [key, setKey] = useState('communal');
    const [activeSlide, setActiveSlide] = useState(0);

    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);
    const [showInviteModal, setShowInviteModal] = useState(false);

    const [isHovered, setIsHovered] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const isMobile = window.innerWidth < 768;
    const formRef = useRef(null);

    const [locations, setLocations] = useState([]);
    const [showMapModal, setShowMapModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const [buildingSearchTerm, setBuildingSearchTerm] = useState('');
    const [doorSearchTerms, setDoorSearchTerms] = useState({});
    const [resiDoorSearchTerms, setResiDoorSearchTerms] = useState({});

    const handleDoorSearchChange = (buildingId, value) => {
        setDoorSearchTerms((prev) => ({ ...prev, [buildingId]: value }));
    };

    const handleResiDoorSearchChange = (buildingId, value) => {
        setResiDoorSearchTerms((prev) => ({ ...prev, [buildingId]: value }));
    };

    const [activeBuildingTab, setActiveBuildingTab] = useState(null);
    const [doorTabKey, setDoorTabKey] = useState({});

    useEffect(() => {
        if (isModalOpen1 && currentStep1 === 2 && selectedBuildings1.length > 0) {
            const firstBuildingId = selectedBuildings1[0];
            setActiveBuildingTab(firstBuildingId);
            setDoorTabKey(prev => ({
                ...prev,
                [firstBuildingId]: 'communal'
            }));
        }
    }, [isModalOpen1, currentStep1]);

    Modal.defaultStyles = {};

    const [inspectorInfos, setInspectorInfos] = useState([]);

    const [building1, setBuilding1] = useState("");
    const [building2, setBuilding2] = useState("");
    const [compare, setCompare] = useState(false);
    const [showCompare, setShowCompare] = useState(false);
    const [compareResult, setCompareResult] = useState(null);
    const [activeTab1, setActiveTab1] = useState('issues');
    const [activeTab2, setActiveTab2] = useState('issues');

    const [displayedText, setDisplayedText] = useState('');

    const recentActivityContainerRef = useRef(null);
    const buildingGroupsRef = useRef(new Map());
    const loadedDoorsRef = useRef({});
    const isFirstFilterRun = useRef(true);

    const [buildingGroups, setBuildingGroups] = useState(new Map());
    const [loadedDoors, setLoadedDoors] = useState({});
    const [doorsLoading, setDoorsLoading] = useState({});
    const [visibleCount, setVisibleCount] = useState(20);
    const [loadingMore, setLoadingMore] = useState(false);
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const [dataReady, setDataReady] = useState(false);
    const [filters, setFilters] = useState({ searchText: '', floor: null, clientName: null, personInCharge: null });
    const [recentActivitySearch, setRecentActivitySearch] = useState('');
    const [recentActivityVisible, setRecentActivityVisible] = useState(20);
    const [recentActivitySuggestions, setRecentActivitySuggestions] = useState([]);
    const [loadingMoreActivity, setLoadingMoreActivity] = useState(false);
    const [statsLocked, setStatsLocked] = useState(false);
    const [statsKey, setStatsKey] = useState(0);

    useEffect(() => { buildingGroupsRef.current = buildingGroups; }, [buildingGroups]);
    useEffect(() => { loadedDoorsRef.current = loadedDoors; }, [loadedDoors]);

    const filteredActivity = recentActivity.filter(a =>
        !recentActivitySearch ||
        a.building.toLowerCase().includes(recentActivitySearch.toLowerCase())
    );
    const visibleActivity = filteredActivity.slice(0, recentActivityVisible);
    const hasMoreActivity = visibleActivity.length < filteredActivity.length;

    const doesReportMatchFilter = (reportInfo, filters) => {
        const filterLowerCase = (filters.searchText || "").trim().toLowerCase();
        const isFilterDate = /^\d{4}-\d{2}-\d{2}$/.test(filterLowerCase);
        const safe = (str) => (str && str.toLowerCase ? str.toLowerCase() : "");

        const matchesText =
            safe(reportInfo.buildingName).includes(filterLowerCase) ||
            safe(reportInfo.buildingType).includes(filterLowerCase) ||
            safe(reportInfo.city).includes(filterLowerCase) ||
            safe(reportInfo.clientAddress).includes(filterLowerCase) ||
            safe(reportInfo.clientName).includes(filterLowerCase) ||
            safe(reportInfo.completedBy).includes(filterLowerCase) ||
            (isFilterDate
                ? safe(reportInfo.date) === filterLowerCase || safe(reportInfo.nextdate) === filterLowerCase
                : safe(reportInfo.date).includes(filterLowerCase) || safe(reportInfo.nextdate).includes(filterLowerCase)
            ) ||
            safe(reportInfo.personInCharge).includes(filterLowerCase) ||
            safe(reportInfo.postcode).includes(filterLowerCase) ||
            safe(reportInfo.reportId).includes(filterLowerCase);

        let matchesFloor = true;
        if (filters.floor) {
            const floorNum = Number(reportInfo.floors);
            let min, max;
            if (filters.floor.includes("+")) {
                min = Number(filters.floor.replace("+", ""));
                max = Infinity;
            } else {
                [min, max] = filters.floor.split("-").map(Number);
            }
            matchesFloor = floorNum >= min && floorNum <= max;
        }

        const matchesClient = filters.clientName ? reportInfo.clientName === filters.clientName : true;
        const matchesPIC = filters.personInCharge ? reportInfo.personInCharge === filters.personInCharge : true;

        return matchesText && matchesFloor && matchesClient && matchesPIC;
    };

    const sortedFilteredData = Object.entries(data)
        .filter(([, { reportInfo }]) => reportInfo?.buildingName && doesReportMatchFilter(reportInfo, filters))
        .sort(([, a], [, b]) => {
            const nameA = a.reportInfo?.buildingName || '';
            const nameB = b.reportInfo?.buildingName || '';
            return nameA.localeCompare(nameB);
        });

    const visibleData = sortedFilteredData.slice(0, visibleCount);
    const hasMore = sortedFilteredData.length > visibleCount;


    // async function openDB() {
    //     return new Promise((resolve, reject) => {
    //         const request = indexedDB.open("DashboardDB", 1);

    //         request.onupgradeneeded = (event) => {
    //             const db = event.target.result;
    //             if (!db.objectStoreNames.contains("dataStore")) {
    //                 db.createObjectStore("dataStore", { keyPath: "id" });
    //                 console.log("Object store created");
    //             }
    //         };

    //         request.onsuccess = (event) => resolve(event.target.result);
    //         request.onerror = (event) => reject(event.target.error);
    //     });
    // }

    // async function saveDataToIndexedDB(data) {
    //     const db = await openDB();
    //     return new Promise((resolve, reject) => {
    //         const tx = db.transaction("dataStore", "readwrite");
    //         const store = tx.objectStore("dataStore");
    //         store.put({ id: "dashboardData", value: data });

    //         tx.oncomplete = () => {
    //             console.log("Data saved successfully");
    //             resolve(true);
    //         };
    //         tx.onerror = (err) => reject(err);
    //     });
    // }

    // async function getDataFromIndexedDB() {
    //     const db = await openDB();
    //     return new Promise((resolve, reject) => {
    //         const tx = db.transaction("dataStore", "readonly");
    //         const store = tx.objectStore("dataStore");
    //         const request = store.get("dashboardData");

    //         request.onsuccess = () => resolve(request.result?.value || null);
    //         request.onerror = (err) => reject(err);
    //     });
    // }
    const [inspectores, setInspectores] = useState([]);

    const fetchInspectores = async () => {
        try {
            const q = query(collection(db, "users"), where("user_role", "==", "inspector"));
            const snapshot = await getDocs(q);
            const list = snapshot.docs
                .map(doc => ({ value: doc.id, label: doc.data().name }))
                .filter(u => u.label);
            setInspectores(list);
        } catch (err) {
            console.error("Error fetching inspectores:", err);
        } finally {
            setLoading(false);
        }
    };


    const [isBookingModalOpen, setIsBookingModalOpen1] = useState(false);
    const [focusedField, setFocusedField] = useState(null);

    const inputStyle = (fieldName) => ({
        height: '44px',
        fontSize: '14px',
        borderRadius: '8px',
        border: focusedField === fieldName ? '1px solid #dc3545' : '1px solid #d0d5dd',
        boxShadow: focusedField === fieldName ? '0 0 0 3px rgba(220, 53, 69, 0.15)' : 'none',
        outline: 'none',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        width: '100%',
    });

    const textareaStyle = (fieldName) => ({
        ...inputStyle(fieldName),
        height: 'auto',
        minHeight: '90px',
        padding: '10px 12px',
    });

    const labelStyle = {
        fontSize: '13px',
        fontWeight: 600,
        color: '#344054',
        marginBottom: '6px',
        display: 'block',
    };

    const sectionTitleStyle = {
        fontSize: '13px',
        fontWeight: 700,
        color: '#6b7280',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        margin: '24px 0 12px',
        paddingBottom: '6px',
        borderBottom: '1px solid #eaecf0',
    };


    const resetRequestForm = () => {
        setRequestFormData({
            companyName: '',
            propertyManagerEmail: '',
            propertyAddress: '',
            fireRiskAssessment: null,
            totalCommunalDoors: '',
            totalResiDoors: '',
            buildingHeight: '',
            payeeName: '',
            payeeAddress: '',
            payeeContactDetails: '',
            payeeEmail: '',
            payeePhone: '',
            frequency: 'Yearly',
            contactResidents: '',
            accessDetails: '',
            onsiteParking: '',
            onsiteParkingDetails: '',

        });
    };

    const [requestFormData, setRequestFormData] = useState({
        companyName: '',
        propertyManagerEmail: '',
        propertyAddress: '',
        fireRiskAssessment: null,
        totalCommunalDoors: '',
        totalResiDoors: '',
        buildingHeight: '',
        payeeName: '',
        payeeAddress: '',
        payeeContactDetails: '',
        payeeEmail: '',
        payeePhone: '',
        frequency: 'Yearly',
        contactResidents: '',
        accessDetails: '',
        onsiteParking: '',
        onsiteParkingDetails: '',
    });

    const handleParkingChange = (value) => {
        setRequestFormData(prev => ({
            ...prev,
            onsiteParking: value,
            onsiteParkingDetails: value === "Yes" ? prev.onsiteParkingDetails : "",
        }));
    };

    const handleRequestFieldChange = (field, value) => {
        setRequestFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleRequestFileChange = (e) => {
        const file = e.target.files?.[0] || null;
        setRequestFormData(prev => ({ ...prev, fireRiskAssessment: file }));
    };

    const handleRequestSubmit = async (e) => {
        e.preventDefault();

        if (!user?.uid) {
            alert("You must be logged in to submit a request.");
            return;
        }

        try {
            setLoading(true);

            const formatDateTime = (date) => {
                const pad = (n) => String(n).padStart(2, '0');
                return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
            };

            const docRef = doc(collection(db, "users", user.uid, "requestInspection"));
            const requestId = docRef.id;

            let fireRiskAssessmentUrl = '';

            if (requestFormData.fireRiskAssessment) {
                const file = requestFormData.fireRiskAssessment;
                const storagePath = `users/${user.uid}/requestInspection/${requestId}/${file.name}`;
                const storageRef = ref(storage, storagePath);

                await uploadBytes(storageRef, file);
                fireRiskAssessmentUrl = await getDownloadURL(storageRef);
            }

            const dataToSave = {
                companyName: requestFormData.companyName || '',
                propertyManagerEmail: requestFormData.propertyManagerEmail || '',
                propertyAddress: requestFormData.propertyAddress || '',
                totalCommunalDoors: requestFormData.totalCommunalDoors || '',
                totalResiDoors: requestFormData.totalResiDoors || '',
                buildingHeight: requestFormData.buildingHeight || '',
                fireRiskAssessmentUrl,
                payeeName: requestFormData.payeeName || '',
                payeeAddress: requestFormData.payeeAddress || '',
                payeeContactDetails: requestFormData.payeeContactDetails || '',
                payeeEmail: requestFormData.payeeEmail || '',
                payeePhone: requestFormData.payeePhone || '',
                frequency: requestFormData.frequency || '',
                contactResidents: requestFormData.contactResidents || '',
                accessDetails: requestFormData.accessDetails || '',
                onsiteParking: requestFormData.onsiteParking || '',
                onsiteParkingDetails: requestFormData.onsiteParkingDetails || '',
                date: formatDateTime(new Date()),
            };

            await setDoc(docRef, dataToSave);

            // console.log("Inspection request saved:", dataToSave);

            toast.info('Inspection request submitted successfully!', {
                toastId: `inspection_request_success_${requestId}`,
                className: 'green-toast',
                icon: <FontAwesomeIcon icon={faCircleCheck} bounce size="sm" style={{ color: "green" }} />,
                progressClassName: 'green-progress-bar',
            });

            setIsBookingModalOpen1(false);
            resetRequestForm();

        } catch (err) {
            console.error("Failed to save inspection request:", err);
            alert("Something went wrong while submitting your request. Please try again.");
        }
        finally {
            setLoading(false);
        }
    };


    const fetchStats = async (data) => {
        try {
            setLoadingData(true);

            setStats([]);

            if (!data || !Object.keys(data).length) {
                setStats([]);
                setLoadingData(false);
                return;
            }

            const { role, uid, user: currentUser } = userData;
            const userEmail = currentUser?.email;

            const freshData = {};
            for (const [key, value] of Object.entries(data)) {
                freshData[key] = {
                    ...value,
                    doorReports: [...(value.doorReports || [])],
                    resiReports: [...(value.resiReports || [])],
                    reportInfo: value.reportInfo ? { ...value.reportInfo } : {}
                };
            }

            let filteredData = {};

            if (!currentUser || role === 'guest') {
                filteredData = Object.fromEntries(
                    Object.entries(freshData).filter(([_, val]) =>
                        val.reportInfo?.email === 'test@gmail.com'
                    )
                );
            } else if (role === 'admin' || role === 'manager' || role === 'inspection' || role === 'coordinator' || role === 'remedial' || role === 'reviewer') {
                filteredData = freshData;
            } else if (role === 'client') {
                filteredData = Object.fromEntries(
                    Object.entries(freshData).filter(([_, val]) =>
                        val.reportInfo?.email === userEmail ||
                        val.reportInfo?.addedBy === uid
                    )
                );
            } else if (role === 'inspector') {
                filteredData = Object.fromEntries(
                    Object.entries(freshData).filter(([_, val]) =>
                        val.reportInfo?.assignedInspector === uid ||
                        (val.reportInfo?.assignedInspectors && val.reportInfo.assignedInspectors.includes(uid))
                    )
                );
            }
            // else if (role === 'reviewer') {
            //     filteredData = Object.fromEntries(
            //         Object.entries(freshData).filter(([_, val]) =>
            //             val.reportInfo?.assignedReviewer === uid ||
            //             (val.reportInfo?.assignedReviewers && val.reportInfo.assignedReviewers.includes(uid))
            //         )
            //     );
            // } 
            else {
                filteredData = freshData;
            }

            const now = new Date();
            now.setHours(0, 0, 0, 0);

            const sevenDaysAgo = new Date(now);
            sevenDaysAgo.setDate(now.getDate() - 7);

            const buildingEntries = Object.entries(filteredData);
            const totalBuildings = buildingEntries.length;


            let totalTrue = 0;
            let totalFalse = 0;
            let totalReq = 0;
            let totalAccess = 0;
            let newThisWeek = 0;
            let totalReports = 0;

            const buildingResults = buildingEntries.map(([name, val]) => {
                const { doorReports = [], resiReports = [] } = val;
                const counts = calculateBuildingCounts(doorReports, resiReports);

                const reportDate = val.reportInfo?.dateCreated
                    ? new Date(val.reportInfo.dateCreated)
                    : null;

                if (reportDate) reportDate.setHours(0, 0, 0, 0);

                const isNew = reportDate && reportDate >= sevenDaysAgo;

                totalTrue += counts.totalTrueCount;
                totalFalse += counts.totalFalseCount;
                totalReq += counts.totalReqAttentionCount;
                totalAccess += counts.totalHasAccessCount;
                totalReports += (doorReports.length + resiReports.length);
                if (isNew) newThisWeek++;

                return {
                    buildingName: name,
                    counts,
                    isNew,
                    totalReports: doorReports.length + resiReports.length
                };
            });

            const complianceRate = totalReports > 0 ? (totalTrue / totalReports) * 100 : 0;

            const allActive = Object.values(filteredData).filter(
                building => building.reportInfo?.surveryCompleted === false
            );

            const currentMonth = now.getMonth();
            const currentYear = now.getFullYear();
            const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
            const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;

            let currentActive = 0;
            let lastActive = 0;

            allActive.forEach(building => {
                const dateStr = building.reportInfo?.date;
                if (!dateStr) return;

                const d = new Date(dateStr);
                if (d.getFullYear() === currentYear && d.getMonth() === currentMonth) {
                    currentActive++;
                } else if (d.getFullYear() === lastMonthYear && d.getMonth() === lastMonth) {
                    lastActive++;
                }
            });

            const improvementPercent = lastActive === 0 ? 0 : ((currentActive - lastActive) / lastActive) * 100;

            const newStats = [
                {
                    icon: faBuilding,
                    title: "Total Buildings",
                    value: totalBuildings.toString(),
                    change: `${newThisWeek} new this week`,
                    color: "primary",
                    filter: "all",
                },
                {
                    icon: faChartLine,
                    title: "Active Inspections",
                    value: allActive.length.toString(),
                    change: `${improvementPercent.toFixed(1)}% from last month`,
                    color: "primary",
                    filter: "active",
                },
                {
                    icon: faCheckCircle,
                    title: "Compliance Rate",
                    value: `${complianceRate.toFixed(1)}%`,
                    change: `${totalTrue} pass, ${totalFalse} fail, ${totalAccess} no access`,
                    color: "success",
                },
                {
                    icon: faExclamationTriangle,
                    title: "Pending Issues",
                    value: totalReq.toString(),
                    change: `${totalReq} need re-inspection`,
                    color: "warning",
                }
            ];

            setStats(newStats);

            return buildingResults;

        } catch (err) {
            console.error("fetchStats error:", err);
        } finally {
            setLoadingData(false);
        }
    };

    const loadDoorsForBuilding = async (buildingName) => {
        if (loadedDoorsRef.current[buildingName]) return;
        setDoorsLoading(prev => ({ ...prev, [buildingName]: true }));

        try {
            const group = buildingGroupsRef.current.get(buildingName) || [];
            if (group.length === 0) return;

            const fetches = group.flatMap(({ docId }) => [
                getDocs(collection(db, 'Reports', docId, 'DoorReports'))
                    .then(snap => ({ docId, type: 'door', snap })),
                getDocs(collection(db, 'Reports', docId, 'ResidentialReports'))
                    .then(snap => ({ docId, type: 'resi', snap })),
            ]);
            const results = await Promise.all(fetches);

            const doorsByDocId = {};
            const resiByDocId = {};
            results.forEach(({ docId, type, snap }) => {
                const store = type === 'door' ? doorsByDocId : resiByDocId;
                store[docId] = snap.docs.map(d => d.data()).filter(d => d.addedBy?.trim());
            });

            const mergeByDoorNumber = (allEntries) => {
                let fallbackIndex = 1;
                const latest = {};
                allEntries
                    .sort((a, b) => a.__sourceDate - b.__sourceDate)
                    .forEach(entry => {
                        if (!entry.doorNumber || entry.doorNumber.trim() === '') {
                            entry.doorNumber = `${fallbackIndex++}`;
                        }
                        if (entry.requiresReview !== true) {
                            const k = entry.doorNumber;
                            if (!latest[k] || entry.__sourceDate > latest[k].__sourceDate) {
                                latest[k] = entry;
                            }
                        }
                    });
                return Object.values(latest);
            };

            const allDoors = group.flatMap(({ docId, date }) =>
                (doorsByDocId[docId] || []).map(d => ({ ...d, __sourceDate: new Date(date) }))
            );
            const allResi = group.flatMap(({ docId, date }) =>
                (resiByDocId[docId] || []).map(d => ({ ...d, __sourceDate: new Date(date) }))
            );

            const merged = {
                doorReports: mergeByDoorNumber(allDoors),
                resiReports: mergeByDoorNumber(allResi),
            };

            loadedDoorsRef.current = { ...loadedDoorsRef.current, [buildingName]: merged };
            setLoadedDoors(prev => ({ ...prev, [buildingName]: merged }));

        } catch (error) {
            console.error('Error loading doors for', buildingName, error);
        } finally {
            setDoorsLoading(prev => ({ ...prev, [buildingName]: false }));
        }
    };

    const loadDoorsForBatch = async (names) => {
        const toLoad = names.filter(name => !loadedDoorsRef.current[name]);
        if (toLoad.length === 0) return;
        await Promise.all(toLoad.map(name => loadDoorsForBuilding(name)));
    };

    const naturalDoorSort = (a, b) => {
        const parse = (val) => {
            const str = (val ?? '').toString().trim();
            const match = str.match(/^(\d+)\s*(.*)$/);
            if (match) {
                return { num: parseInt(match[1], 10), suffix: match[2].toLowerCase() };
            }
            return { num: Infinity, suffix: str.toLowerCase() };
        };

        const pa = parse(a.doorNumber);
        const pb = parse(b.doorNumber);

        if (pa.num !== pb.num) return pa.num - pb.num;
        return pa.suffix.localeCompare(pb.suffix);
    };

    let latestReportsByBuilding = {};

    useEffect(() => {
        if (currentStep1 === 2 && selectedBuildings1.length > 0) {
            selectedBuildings1.forEach((buildingId) => {
                const building = latestReportsByBuilding.find((b) => b.uid === buildingId);
                if (building?.buildingName) {
                    loadDoorsForBuilding(building.buildingName);
                }
            });
        }
    }, [currentStep1, selectedBuildings1, latestReportsByBuilding]);

    const buildReportsFromDocs = (combinedDocs) => {
        let signOffCount = 0;
        const reportInfoMap = new Map();
        const newBuildingGroups = new Map();
        const nestedReports = {};

        combinedDocs.forEach(doc => {
            const d = doc.data();
            const uid = doc.id;
            if (!d.buildingName) return;

            const reportInfo = {
                _docId: uid,
                buildingLink: d.buildingLink,
                buildingVideoLink: d.buildingVideoLink,
                buildingName: d.buildingName,
                buildingType: d.buildingType,
                city: d.city,
                clientAddress: d.clientAddress,
                clientName: d.clientName,
                completedBy: d.completedBy,
                date: d.date,
                dateCreated: d.dateCreated,
                dateUpdated: d.dateUpdated,
                nextDate: d.nextDate,
                floors: d.floors,
                communalMonths: d.communalMonths,
                personInCharge: d.personInCharge,
                postcode: d.postcode,
                reportId: d.reportId,
                surveryCompleted: d.surveryCompleted,
                excelLink: d.excelLink,
                pdfLink: d.pdfLink,
                pdfResiLink: d.pdfResiLink,
                uid: d.uid,
                signOff: d.signOff || false,
                logo: d.logo,
                email: d.email,
                autoSchedule: d.autoSchedule || false,
            };

            reportInfoMap.set(uid, reportInfo);

            nestedReports[uid] = {
                reportInfo: reportInfo,
                doorReports: [],
                resiReports: []
            };

            if (!d.signOff) signOffCount++;

            let group = newBuildingGroups.get(d.buildingName);
            if (!group) { group = []; newBuildingGroups.set(d.buildingName, group); }
            group.push({ docId: uid, date: d.date });
        });

        newBuildingGroups.forEach(group =>
            group.sort((a, b) => new Date(b.date) - new Date(a.date))
        );

        const buildingsWithPrevious = [];

        newBuildingGroups.forEach((group, name) => {
            if (group.length > 1) buildingsWithPrevious.push(name);
            const latestReportInfo = reportInfoMap.get(group[0].docId);
            if (!latestReportInfo) return;
            latestReportsByBuilding[name] = {
                reportInfo: latestReportInfo,
                doorReports: [],
                resiReports: [],
            };
        });

        return {
            reportInfoMap,
            newBuildingGroups,
            buildingsWithPrevious,
            latestReportsByBuilding,
            signOffCount,
            nestedReports,
        };
    };

    const userData = useUserRole();

    const fetchCombinedDocs = async (reportsRef, orderByDate = false) => {
        const { role, uid } = userData;
        const userEmail = user?.email;

        const fetchAndDedupe = async (queries) => {
            const results = await Promise.all(queries);
            const seenIds = new Set();
            const docs = [];

            results.forEach(result => {
                if (result && result.docs) {
                    result.docs.forEach(doc => {
                        if (!seenIds.has(doc.id)) {
                            seenIds.add(doc.id);
                            docs.push(doc);
                        }
                    });
                }
            });

            return docs;
        };

        const sortDocsByDate = (docs) => {
            return docs.sort((a, b) => {
                const dateA = a.data()?.date?.toMillis?.() ?? 0;
                const dateB = b.data()?.date?.toMillis?.() ?? 0;
                return orderByDate ? dateB - dateA : dateA - dateB;
            });
        };

        try {
            if (!user || role === 'guest') {
                const snap = await getDocs(
                    query(reportsRef, where('email', '==', 'test@gmail.com'))
                );
                return snap.docs.map(doc => doc);
            }

            else if (role === 'admin' || role === 'manager' || role === 'inspection' || role === 'coordinator' || role === 'remedial' || role === 'reviewer') {
                const q = orderByDate
                    ? query(reportsRef, orderBy('date', 'desc'))
                    : query(reportsRef);
                const snap = await getDocs(q);
                return snap.docs.map(doc => doc);
            }

            else if (role === 'client') {
                const q = orderByDate
                    ? query(reportsRef, where('email', '==', userEmail), orderBy('date', 'desc'))
                    : query(reportsRef, where('email', '==', userEmail));
                const snap = await getDocs(q);
                return snap.docs.map(doc => doc);
            }

            else if (role === 'inspector') {
                const queries = [
                    getDocs(
                        orderByDate
                            ? query(reportsRef, where('assignedInspector', '==', uid), orderBy('date', 'desc'))
                            : query(reportsRef, where('assignedInspector', '==', uid))
                    ),
                    getDocs(
                        orderByDate
                            ? query(reportsRef, where('assignedInspectors', 'array-contains', uid), orderBy('date', 'desc'))
                            : query(reportsRef, where('assignedInspectors', 'array-contains', uid))
                    )
                ];

                const docs = await fetchAndDedupe(queries);
                return sortDocsByDate(docs);
            }

            // else if (role === 'reviewer') {
            //     const queries = [
            //         getDocs(
            //             orderByDate
            //                 ? query(reportsRef, where('assignedReviewer', '==', uid), orderBy('date', 'desc'))
            //                 : query(reportsRef, where('assignedReviewer', '==', uid))
            //         ),
            //         getDocs(
            //             orderByDate
            //                 ? query(reportsRef, where('assignedReviewers', 'array-contains', uid), orderBy('date', 'desc'))
            //                 : query(reportsRef, where('assignedReviewers', 'array-contains', uid))
            //         )
            //     ];

            //     const docs = await fetchAndDedupe(queries);
            //     return sortDocsByDate(docs);
            // }

            return [];

        } catch (error) {
            console.error('Error in fetchCombinedDocs:', error);
            return [];
        }
    };



    const fetchDoorReports = async () => {
        setLoading(true);
        try {
            const reportsRef = collection(db, 'Reports');
            const combinedDocs = await fetchCombinedDocs(reportsRef, true);
            const { reportInfoMap, newBuildingGroups, buildingsWithPrevious, latestReportsByBuilding, signOffCount } =
                buildReportsFromDocs(combinedDocs);

            buildingGroupsRef.current = newBuildingGroups;
            loadedDoorsRef.current = {};

            setData(latestReportsByBuilding);
            setSignOffCount(signOffCount);
            setReportInfos([...reportInfoMap.values()]);
            setBuildingGroups(newBuildingGroups);
            setBuildingsWithPreviousReports(buildingsWithPrevious);
            setLoadedDoors({});
            setVisibleCount(20);

            const first20 = [...newBuildingGroups.keys()]
                .sort((a, b) => a.localeCompare(b))
                .slice(0, 20);
            loadDoorsForBatch(first20);

        } catch (error) {
            console.error('Error fetching reports:', error);
        } finally {
            setDataReady(true);
            setLoading(false);
        }
    };

    const fetchAllDoorReports = async () => {
        try {
            const reportsRef = collection(db, 'Reports');
            const combinedDocs = await fetchCombinedDocs(reportsRef, false);
            const { reportInfoMap, newBuildingGroups, buildingsWithPrevious, latestReportsByBuilding, signOffCount, nestedReports } =
                buildReportsFromDocs(combinedDocs);

            buildingGroupsRef.current = newBuildingGroups;
            loadedDoorsRef.current = {};

            setSignOffCount(signOffCount);
            setReportInfos([...reportInfoMap.values()]);
            setBuildingGroups(newBuildingGroups);
            setBuildingsWithPreviousReports(buildingsWithPrevious);
            setLoadedDoors({});
            setData(latestReportsByBuilding);
            setVisibleCount(20);
            setDataReady(true);

            const activity = buildRecentActivity(latestReportsByBuilding, nestedReports);
            fetchStats(latestReportsByBuilding);
            fetchInspectores();

            if (activity?.length > 0) {
                const first20 = activity.slice(0, 20).map(a => a.building).filter(Boolean);
                loadDoorsForBatch(first20);
            }

        } catch (error) {
            console.error('Error fetching door reports:', error);
        }
    };

    const inheritBuildingMetadata = async (latestReportsByBuilding, nestedReports) => {
        if (!nestedReports) {
            return;
        }

        const parseDate = (dateStr) => {
            if (!dateStr) return new Date(0);

            const date = new Date(dateStr.replace(' ', 'T'));

            if (isNaN(date.getTime())) {
                const datePart = dateStr.split(' ')[0];
                return new Date(datePart);
            }

            return date;
        };

        const buildingGroups = new Map();

        Object.entries(nestedReports).forEach(([key, report]) => {
            const buildingName = report.reportInfo.buildingName;
            const date = parseDate(report.reportInfo.date);

            if (!buildingGroups.has(buildingName)) {
                buildingGroups.set(buildingName, []);
            }
            buildingGroups.get(buildingName).push({ key, report, date });
        });

        for (const [buildingName, reports] of buildingGroups.entries()) {
            reports.sort((a, b) => b.date - a.date);

            const latest = reports[0].report;
            const latestDocId = reports[0].key;
            const latestDocRef = doc(db, 'Reports', latestDocId);
            const updates = {};

            if (!latest.reportInfo.buildingLink) {
                const olderWithLink = reports
                    .slice(1)
                    .find(({ report }) => report.reportInfo.buildingLink);

                if (olderWithLink) {
                    const inheritedLink = olderWithLink.report.reportInfo.buildingLink;
                    latest.reportInfo.buildingLink = inheritedLink;
                    updates.buildingLink = inheritedLink;

                    if (latestReportsByBuilding[buildingName]) {
                        latestReportsByBuilding[buildingName].reportInfo.buildingLink = inheritedLink;
                    }
                }
            }

            if (!latest.reportInfo.logo) {
                const olderWithLogo = reports
                    .slice(1)
                    .find(({ report }) => report.reportInfo.logo);

                if (olderWithLogo) {
                    const inheritedLogo = olderWithLogo.report.reportInfo.logo;
                    latest.reportInfo.logo = inheritedLogo;
                    updates.logo = inheritedLogo;

                    if (latestReportsByBuilding[buildingName]) {
                        latestReportsByBuilding[buildingName].reportInfo.logo = inheritedLogo;
                    }
                }
            }

            if (!latest.reportInfo.floors) {
                const olderWithFloors = reports
                    .slice(1)
                    .find(({ report }) => report.reportInfo.floors);

                if (olderWithFloors) {
                    const inheritedFloors = olderWithFloors.report.reportInfo.floors;
                    latest.reportInfo.floors = inheritedFloors;
                    updates.floors = inheritedFloors;

                    if (latestReportsByBuilding[buildingName]) {
                        latestReportsByBuilding[buildingName].reportInfo.floors = inheritedFloors;
                    }
                }
            }

            if (!latest.reportInfo.communalMonths) {
                const olderWithCommunalMonths = reports
                    .slice(1)
                    .find(({ report }) => report.reportInfo.communalMonths);

                if (olderWithCommunalMonths) {
                    const inheritedCommunalMonths = olderWithCommunalMonths.report.reportInfo.communalMonths;
                    latest.reportInfo.communalMonths = inheritedCommunalMonths;
                    updates.communalMonths = inheritedCommunalMonths;

                    if (latestReportsByBuilding[buildingName]) {
                        latestReportsByBuilding[buildingName].reportInfo.communalMonths = inheritedCommunalMonths;
                    }
                }
            }

            if (latest.reportInfo.autoSchedule === undefined) {
                const olderWithAutoSchedule = reports
                    .slice(1)
                    .find(({ report }) => report.reportInfo.autoSchedule !== undefined);

                if (olderWithAutoSchedule) {
                    const inheritedAutoSchedule = olderWithAutoSchedule.report.reportInfo.autoSchedule;
                    latest.reportInfo.autoSchedule = inheritedAutoSchedule;
                    updates.autoSchedule = inheritedAutoSchedule;

                    if (latestReportsByBuilding[buildingName]) {
                        latestReportsByBuilding[buildingName].reportInfo.autoSchedule = inheritedAutoSchedule;
                    }
                }
            }

            if (Object.keys(updates).length > 0) {
                try {
                    await updateDoc(latestDocRef, updates);
                } catch (error) {
                    console.error('Error updating Firestore:', error);
                }
            }
        }
    };

    const buildRecentActivity = (latestReportsByBuilding, nestedReports) => {
        if (!latestReportsByBuilding || Object.keys(latestReportsByBuilding).length === 0) return [];

        const { role, uid, user: currentUser } = userData;
        const userEmail = currentUser?.email;

        let allBuildings = Object.values(latestReportsByBuilding).filter(b => b && b.reportInfo);
        let filteredBuildings = [];

        if (!currentUser || role === 'guest') {
            filteredBuildings = allBuildings.filter(b => b.reportInfo?.email === "test@gmail.com");
        }

        else if (role === 'admin' || role === 'manager' || role === 'inspection' || role === 'coordinator' || role === 'remedial' || role === 'reviewer') {
            filteredBuildings = allBuildings;
            inheritBuildingMetadata(latestReportsByBuilding, nestedReports);
        }

        else if (role === 'client') {
            filteredBuildings = allBuildings.filter(b =>
                b.reportInfo?.email === userEmail
            );
        }
        else if (role === 'inspector') {
            filteredBuildings = allBuildings.filter(b =>
                b.reportInfo?.assignedInspector === uid ||
                (b.reportInfo?.assignedInspectors && b.reportInfo.assignedInspectors.includes(uid))
            );
        }

        // else if (role === 'reviewer') {
        //     filteredBuildings = allBuildings.filter(b =>
        //         b.reportInfo?.assignedReviewer === uid ||
        //         (b.reportInfo?.assignedReviewers && b.reportInfo.assignedReviewers.includes(uid))
        //     );
        // }
        else {
            filteredBuildings = allBuildings.filter(b =>
                b.reportInfo?.email === userEmail
            );
        }

        const activityList = filteredBuildings.map(b => {
            const { reportInfo = {} } = b;
            const doors = loadedDoorsRef.current[reportInfo.buildingName];
            const { totalTrueCount, totalFalseCount, totalReqAttentionCount, totalHasAccessCount } =
                doors
                    ? calculateBuildingCounts(doors.doorReports, doors.resiReports)
                    : { totalTrueCount: 0, totalFalseCount: 0, totalReqAttentionCount: 0, totalHasAccessCount: 0 };

            let status = "Passed";
            let statusColor = "success";
            if (totalReqAttentionCount > 0) { status = "Re-Inspection"; statusColor = "warning"; }
            else if (totalFalseCount > 0) { status = "Issues"; statusColor = "danger"; }

            const dateString = reportInfo.date || reportInfo.nextDateResidential || reportInfo.nextDate;
            const formattedDate = dateString
                ? new Date(dateString).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
                : "—";

            return {
                building: reportInfo.buildingName || "Unknown Building",
                buildingUID: reportInfo.uid || "",
                date: formattedDate,
                greenCount: totalTrueCount,
                redCount: totalFalseCount,
                yellowCount: totalReqAttentionCount,
                greyCount: totalHasAccessCount,
                status,
                statusColor,
                image: reportInfo.buildingLink || defaultImage,
            };
        });

        const sorted = activityList.sort((a, b) => new Date(b.date) - new Date(a.date));
        setRecentActivity(sorted);
        return sorted;
    };

    useEffect(() => {
        if (!dataReady || recentActivity.length === 0) return;

        const namesToLoad = (() => {
            if (recentActivitySearch?.trim().length >= 2) {
                const lower = recentActivitySearch.toLowerCase();
                return recentActivity
                    .filter(a => a.building?.toLowerCase().includes(lower))
                    .map(a => a.building)
                    .filter(name => name && !loadedDoorsRef.current[name])
                    .slice(0, 20);
            }
            return recentActivity
                .slice(0, recentActivityVisible)
                .map(a => a.building)
                .filter(name => name && !loadedDoorsRef.current[name]);
        })();

        if (namesToLoad.length === 0) return;

        const isSearch = recentActivitySearch?.trim().length >= 2;
        if (isSearch) {
            const timer = setTimeout(() => loadDoorsForBatch(namesToLoad), 400);
            return () => clearTimeout(timer);
        }

        loadDoorsForBatch(namesToLoad);

    }, [recentActivity.length, recentActivitySearch, recentActivityVisible, dataReady]);

    useEffect(() => {
        if (!dataReady) return;

        setRecentActivity(prev => {
            let changed = false;
            const next = prev.map(activity => {
                const isLoading = !!doorsLoading[activity.building];
                if (isLoading && activity.status !== "Loading...") {
                    changed = true;
                    return { ...activity, status: "Loading...", statusColor: "secondary" };
                }
                return activity;
            });
            return changed ? next : prev;
        });
    }, [doorsLoading, dataReady]);

    useEffect(() => {
        if (!dataReady) return;

        const loadedNames = Object.keys(loadedDoors);
        if (loadedNames.length === 0) return;

        setRecentActivity(prev => {
            let changed = false;
            const next = prev.map(activity => {
                const doors = loadedDoors[activity.building];

                if (!doors) {
                    if (doorsLoading[activity.building] === false && activity.status === "Loading...") {
                        changed = true;
                        return { ...activity, status: "N/A", statusColor: "secondary" };
                    }
                    return activity;
                }

                const { totalTrueCount, totalFalseCount, totalReqAttentionCount, totalHasAccessCount } =
                    calculateBuildingCounts(doors.doorReports, doors.resiReports);

                if (totalTrueCount === 0 && totalFalseCount === 0 && totalReqAttentionCount === 0 && totalHasAccessCount === 0) {
                    if (activity.status === "N/A") return activity;
                    changed = true;
                    return { ...activity, status: "N/A", statusColor: "secondary" };
                }

                if (
                    activity.greenCount === totalTrueCount &&
                    activity.redCount === totalFalseCount &&
                    activity.yellowCount === totalReqAttentionCount &&
                    activity.greyCount === totalHasAccessCount &&
                    activity.status !== "Loading..."
                ) return activity;

                changed = true;

                let status = "Passed";
                let statusColor = "success";
                if (totalReqAttentionCount > 0) { status = "Re-Inspection"; statusColor = "warning"; }
                else if (totalFalseCount > 0) { status = "Issues"; statusColor = "danger"; }

                return {
                    ...activity,
                    greenCount: totalTrueCount,
                    redCount: totalFalseCount,
                    yellowCount: totalReqAttentionCount,
                    greyCount: totalHasAccessCount,
                    status,
                    statusColor,
                };
            });

            return changed ? next : prev;
        });
    }, [loadedDoors, doorsLoading, dataReady]);

    useEffect(() => {
        if (visibleActivity.length === 0 || stats.length === 0) return;
        if (statsLocked) return;

        let totalTrue = 0, totalFalse = 0, totalReq = 0, totalAccess = 0, totalReports = 0;

        visibleActivity.forEach(activity => {
            const doors = loadedDoors[activity.building];
            if (!doors) return;
            const counts = calculateBuildingCounts(doors.doorReports, doors.resiReports);
            totalTrue += counts.totalTrueCount;
            totalFalse += counts.totalFalseCount;
            totalReq += counts.totalReqAttentionCount;
            totalAccess += counts.totalHasAccessCount;
            totalReports += (doors.doorReports?.length || 0) + (doors.resiReports?.length || 0);
        });

        if (totalReports === 0) return;

        const complianceRate = totalReports ? (totalTrue / totalReports) * 100 : 0;
        const newComplianceValue = `${complianceRate.toFixed(1)}%`;
        const newComplianceChange = `${totalTrue} pass, ${totalFalse} fail, ${totalAccess} no access`;
        const newPendingValue = totalReq.toString();
        const newPendingChange = `${totalReq} need re-inspection`;

        setStats(prev => {
            const complianceStat = prev.find(s => s.title === 'Compliance Rate');
            const pendingStat = prev.find(s => s.title === 'Pending Issues');

            if (complianceStat?.value === newComplianceValue &&
                pendingStat?.value === newPendingValue) {
                return prev;
            }

            return prev.map(s => {
                if (s.title === 'Compliance Rate') return {
                    ...s,
                    value: newComplianceValue,
                    change: newComplianceChange,
                };
                if (s.title === 'Pending Issues') return {
                    ...s,
                    value: newPendingValue,
                    change: newPendingChange,
                };
                return s;
            });
        });

        if (!statsAnimatedRef.current) {
            statsAnimatedRef.current = true;
        }

    }, [visibleActivity, loadedDoors, statsLocked]);

    useEffect(() => {
        if (loadingAuth) return;
        if (!userData.ready) return;

        setData({});
        setStats([]);
        setDataReady(false);
        isFirstFilterRun.current = true;

        const run = async () => {
            setLoading(true);
            try {
                await fetchAllDoorReports();
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        run();
        window.scrollTo(0, 0);
    }, [userData.ready, userData.role]);

    const handleFilterClick = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setVisibleCount(20);
    };

    const handleSearchInput = (value) => {
        if (value.trim().length < 2) { setSearchSuggestions([]); return; }
        const lower = value.toLowerCase();
        const matches = [...buildingGroupsRef.current.keys()]
            .filter(name => name && typeof name === 'string' && name.toLowerCase().includes(lower))
            .sort((a, b) => a.localeCompare(b))
            .slice(0, 8);
        setSearchSuggestions(matches);
    };

    const handleSuggestionClick = async (name) => {
        handleFilterClick("searchText", name);
        setSearchSuggestions([]);
        const allSortedNames = [...buildingGroupsRef.current.keys()]
            .filter(n => n && typeof n === 'string')
            .sort((a, b) => a.localeCompare(b));
        const idx = allSortedNames.indexOf(name);
        if (idx !== -1) setVisibleCount(prev => Math.max(prev, idx + 1));
        await loadDoorsForBuilding(name);
    };

    const handleLoadMore = async () => {
        setLoadingMore(true);
        try {
            const allSortedNames = sortedFilteredData.map(([, { reportInfo }]) => reportInfo.buildingName);
            const nextBatch = allSortedNames.slice(visibleCount, visibleCount + 20);
            await loadDoorsForBatch(nextBatch);
            setVisibleCount(prev => prev + 20);
        } finally {
            setLoadingMore(false);
        }
    };

    const handleRecentActivitySearch = (value) => {
        setRecentActivitySearch(value);
        setRecentActivityVisible(20);
        if (value.trim().length < 2) { setRecentActivitySuggestions([]); return; }
        const lower = value.toLowerCase();
        const matches = recentActivity
            .map(a => a.building)
            .filter(name => name && name.toLowerCase().includes(lower))
            .sort((a, b) => a.localeCompare(b))
            .slice(0, 8);
        setRecentActivitySuggestions(matches);
    };

    const handleLoadMoreActivity = async () => {
        const nextBatch = filteredActivity
            .slice(recentActivityVisible, recentActivityVisible + 20)
            .map(a => a.building)
            .filter(name => name && !loadedDoorsRef.current[name]);

        setRecentActivityVisible(prev => prev + 20);

        if (nextBatch.length > 0) {
            setLoadingMoreActivity(true);
            setStatsLocked(true);
            try {
                await loadDoorsForBatch(nextBatch);
            } finally {
                setLoadingMoreActivity(false);
                setStatsLocked(false);
                setStatsKey(prev => prev + 1);
            }
        }
    };


    const calculateBuildingCounts = (doorReports = [], resiReports = []) => {
        const combined = [...doorReports, ...resiReports];
        let totalTrue = 0, totalFalse = 0, totalReq = 0, totalAccess = 0;

        for (let i = 0; i < combined.length; i++) {
            const d = combined[i];
            let t = 0, f = 0, r = 0, a = 0;

            const d1 = +d.fD1 || 0, d2 = +d.fD2 || 0, d3 = +d.fD3 || 0, d4 = +d.fD4 || 0;
            const cond1 = d1 <= 4 && d2 <= 4 && d3 <= 4;
            const cond2 = d4 <= 8;

            d.doorCloseAsIntented === false ? f++ : t++;
            if ("doorStrips" in d) d.doorStrips ? t++ : f++;
            d.hingesWorking ? t++ : f++;
            d.hingesFireRating ? t++ : f++;

            const dm = (d.damageMultiples || []).map(String);
            if (dm.length === 1 && dm[0] === "None") t++;
            else {
                const ok =
                    (dm.includes("Door Pass") || !dm.includes("Door")) &&
                    (dm.includes("Frame Pass") || !dm.includes("Frame")) &&
                    (dm.includes("Glass None") || dm.includes("Glass Pass") || !dm.includes("Glass")) &&
                    (dm.includes("Ventilation Gaps None") || dm.includes("Ventilation Gaps Pass") || !dm.includes("Ventilation Gaps"));
                ok ? t++ : f++;
            }

            const cert = d.doorCertif || "";
            cert && !cert.includes("No") ? t++ : f++;

            cond1 && cond2 ? t++ : f++;

            if (d.requiresAttention) r++;
            if (d.hasAccess === false) a++;

            if (!r && !a) {
                f >= 1 ? totalFalse++ : totalTrue++;
            } else {
                if (r) totalReq++;
                if (a) totalAccess++;
            }
        }

        return { totalTrueCount: totalTrue, totalFalseCount: totalFalse, totalReqAttentionCount: totalReq, totalHasAccessCount: totalAccess };
    };


    // useEffect(() => {
    //     if (recentActivity.length > 0) {
    //         const timer = setTimeout(() => {
    //             const baseDurationPerItem = 2000;
    //             const duration = recentActivity.length * baseDurationPerItem;

    //             animateScroll.scrollToBottom({
    //                 containerId: 'recentActivityContainer',
    //                 duration,
    //                 smooth: 'easeOutQuad'
    //             });
    //         }, 1500);

    //         return () => clearTimeout(timer);
    //     }
    // }, [recentActivity]);

    const fetchData = async () => {
        try {
            await fetchAllDoorReports(user);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    useEffect(() => {
        if (loadingAuth) {
            const timer = setTimeout(() => setLoading(false), 2000);
            return () => clearTimeout(timer);
        } else {
            setLoading(false);
        }

        fetchData();
        window.scrollTo(0, 0);

    }, [user, loadingAuth]);


    const statsAnimatedRef = useRef(false);

    function AnimatedNumbers({ text, duration = 1000, animKey }) {
        const [displayText, setDisplayText] = useState(text);
        const frameRef = useRef(null);
        const textRef = useRef(text);

        useEffect(() => {
            textRef.current = text;
        }, [text]);

        useEffect(() => {
            if (frameRef.current) cancelAnimationFrame(frameRef.current);

            const currentText = textRef.current;
            const numbers = [...currentText.matchAll(/\d+/g)];
            if (!numbers.length) { setDisplayText(currentText); return; }

            const starts = numbers.map(() => 0);
            const ends = numbers.map(n => parseInt(n[0], 10));
            const steps = ends.map(end => Math.max(1, end / (duration / 16)));

            const update = () => {
                let done = true;
                let index = 0;
                const newText = currentText.replace(/\d+/g, () => {
                    starts[index] = Math.min(ends[index], starts[index] + steps[index]);
                    if (starts[index] < ends[index]) done = false;
                    const value = Math.round(starts[index]);
                    index++;
                    return value;
                });
                setDisplayText(newText);
                if (!done) frameRef.current = requestAnimationFrame(update);
                else setDisplayText(currentText);
            };

            frameRef.current = requestAnimationFrame(update);
            return () => { if (frameRef.current) cancelAnimationFrame(frameRef.current); };
        }, [animKey]);

        return <>{displayText}</>;
    }

    const quickActions = [

        {
            icon: faFileAlt,
            title: 'Send Work',
            description: 'Share reports for chosen doors.',
            color: 'warning',
            onClick: () => {
                if (user) {
                    setIsModalOpen1(true);
                    resetModal1();
                } else {
                    setShowInviteModal(true);
                }
            }
        },
        {
            icon: faCalendarCheck,
            title: 'Request Inspection',
            description: 'Submit details to request inspection.',
            color: 'success',
            onClick: () => {
                if (user) {
                    setIsBookingModalOpen1(true);
                    resetModal1();
                } else {
                    setShowInviteModal(true);
                }
            }
        },
        {
            icon: faCalendarAlt,
            title: 'Calendar',
            description: 'View upcoming inspections',
            color: 'primary',
            onClick: () => {
                goToPage('calendar');
            }
        },
        {
            icon: faClipboardList,
            title: 'Book Inspection',
            description: 'Reserve an inspection slot',
            color: 'secondary',
            onClick: () => {
                goToPage('booking');
            }
        },
    ];


    const goToReports = (filter) => {
        if (!data || Object.keys(data).length === 0) {
            console.warn("No data available to navigate");
            return;
        }

        let reportsToSend = {};

        if (filter === 'active') {
            // Filter for active surveys
            Object.entries(data).forEach(([buildingName, building]) => {
                if (building.reportInfo && building.reportInfo.surveryCompleted === false) {
                    reportsToSend[buildingName] = building;
                }
            });
        } else if (filter === 'all') {
            reportsToSend = data;
        }
        if (Object.keys(reportsToSend).length > 0) {
            navigate('/reports', {
                state: {
                    reportsData: reportsToSend,
                    filterType: filter,
                },
            });
        } else {
            console.warn("No reports match the filter:", filter);
        }
    };




    const handleReportClick = (uid, buildingData, totalTrueCount, totalFalseCount) => {
        if (user) {
            navigate(`/doors/${uid}`, {
                state: { buildingData, totalTrueCount, totalFalseCount }
            });
        } else {
            setShowInviteModal(true);
        }
    };


    const formatDate1 = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear().toString().slice(-2);
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${day}/${month}/${year}`;
    };

    const handleBuildingFilterChange = (buildingId, filter) => {
        setDoorFilters(prevState => ({
            ...prevState,
            [buildingId]: filter,
        }));
    };
    const handleBuildingFilterChange1 = (buildingId, filter) => {
        setResiDoorFilters(prevState => ({
            ...prevState,
            [buildingId]: filter,
        }));
    };

    const goToPage = (page) => {
        if (user) {
            if (page === 'calendar') {
                navigate('/calendar');
            }
            else if (page === 'booking') {
                navigate('/book-inspection');
            }
        }
        else {
            setShowInviteModal(true);
        }
    };


    //1sttModal


    //2ndModal
    const addEmail = (email) => {
        if (email.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            if (emails.includes(email.trim())) {
                alert("This email has already been added.");
            } else {
                setEmails([...emails, email.trim()]);
            }
        } else {
            alert("Please enter a valid email.");
        }
    };

    const removeEmail = (index) => {
        setEmails(emails.filter((_, i) => i !== index));
    };

    latestReportsByBuilding = Object.values(
        reportInfos.reduce((acc, report) => {
            // if (report.signOff) {
            const buildingName = report.buildingName;
            if (!acc[buildingName] || new Date(report.date) > new Date(acc[buildingName].date)) {
                acc[buildingName] = { ...report, uid: report.uid };
            }
            // }
            return acc;
        }, {})
    );

    const resetModal1 = () => {
        setCurrentStep1(1);
        setSelectedBuildings1([]);
        setSelectedBuildingsDoor([]);
        setSelectedInspector1(null);
        setInspectionDate('');
        setEmails([]);
        setDoorFilters([]);
        setSelectedData([]);
        setKey('communal');
    }

    const handleBuildingSelection1 = (buildingId, building) => {
        // console.log("Selected buildingId:", buildingId);

        setSelectedBuildings1((prevSelected) => {
            const isSelected = prevSelected.includes(buildingId);
            const newSelected = isSelected
                ? prevSelected.filter((id) => id !== buildingId)
                : [...prevSelected, buildingId];

            setSelectedData((prevData) => {
                const updatedData = { ...prevData };

                if (isSelected) {
                    delete updatedData[buildingId];
                } else {
                    updatedData[buildingId] = { building, doors: [] };
                }

                // console.log("Updated Selected Data:", updatedData);
                return updatedData;
            });

            // console.log("Updated Selected Buildings:", newSelected);
            return newSelected;
        });
    };

    const handleDoorSelection1 = useCallback((uid, buildingId, door) => {
        if (!uid || !buildingId || !door) return;

        setSelectedBuildingsDoor(prev => {
            const currentDoors = prev[buildingId] || [];
            const isSelected = currentDoors.includes(uid);

            const newDoors = isSelected
                ? currentDoors.filter(id => id !== uid)
                : [...currentDoors, uid];

            setSelectedData(prevData => {
                const buildingData = prevData[buildingId] || { doors: [] };
                let updatedDoors;

                if (isSelected) {
                    updatedDoors = buildingData.doors.filter(d => d.uid !== uid);
                } else {
                    updatedDoors = buildingData.doors.some(d => d.uid === uid)
                        ? buildingData.doors
                        : [...buildingData.doors, { ...door, uid }];
                }

                const sortedDoors = [...updatedDoors].sort(sortDoorsByType);

                return {
                    ...prevData,
                    [buildingId]: {
                        ...buildingData,
                        doors: sortedDoors
                    }
                };
            });

            return {
                ...prev,
                [buildingId]: newDoors
            };
        });
    }, []);

    const sortDoorsByType = (a, b) => {
        if (a.type === 'communal' && b.type === 'residential') return -1;
        if (a.type === 'residential' && b.type === 'communal') return 1;
        return (parseInt(a.doorNumber) || 0) - (parseInt(b.doorNumber) || 0);
    };


    const handleInspectorSelection1 = (inspector) => {
        if (selectedInspector1 && selectedInspector1.uid === inspector.uid) {
            setSelectedInspector1(null);
        } else {
            setSelectedInspector1(inspector);
        }
    };


    const handleNextStep1 = () => {
        if (currentStep1 < 4 && selectedBuildings1.length > 0) {
            setCurrentStep1(currentStep1 + 1);
        }
    };

    const handleBackStep1 = () => {
        if (currentStep1 > 1) {
            setCurrentStep1(currentStep1 - 1);
        }
    };


    const makePdf = async (user, buildingData, doorIds) => {
        setLoading(true);

        try {
            const doorDataArray = selectedData[buildingData.uid]?.doors || [];
            if (!Array.isArray(doorDataArray)) {
                console.error(`Expected an array for doors in building ${buildingData.uid}, got:`, doorDataArray);
                setLoading(false);
                return null;
            }

            const selectedDoors = doorIds.map((doorId) => {
                const doorData = doorDataArray.find((d) => d.uid === doorId);
                if (!doorData) {
                    return null;
                }

                return { ...doorData, buildingName: buildingData.buildingName };
            }).filter(Boolean);

            const payload = {
                doorReports: selectedDoors,
                report: buildingData,
            };

            // console.log("Payload for PDF Export:", payload);

            // const response = await fetch("http://localhost:8080/export-to-pdf", {
            const response = await fetch("https://firechecked-gcp-813451531907.europe-west1.run.app/export-to-pdf", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const pdfBlob = await response.blob();

                const now = new Date();
                const formattedDate = now.toISOString().replace(/T/, '__').replace(/\..+/, '');
                const formattedTimestamp = formattedDate.replace(/:/g, '_');

                const storageRef = ref(storage, `users/${user.uid}/requestedMaintainence/Report_${formattedTimestamp}.pdf`);
                const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

                const downloadURL = await new Promise((resolve, reject) => {
                    uploadTask.on(
                        "state_changed",
                        (snapshot) => { },
                        (error) => {
                            console.error("Error uploading PDF:", error);
                            reject("Error uploading PDF");
                        },
                        async () => {
                            try {
                                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                                resolve(downloadURL);
                            } catch (error) {
                                console.error("Error getting download URL:", error);
                                reject("Error getting download URL");
                            }
                        }
                    );
                });

                return downloadURL;
            } else {
                throw new Error(`Failed with status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error exporting PDF:", error);
            alert("An error occurred while exporting the PDF.");
            throw error;
        } finally {
            setLoading(false);
        }
    };


    const handleModalSubmit1 = async () => {
        if (selectedBuildings1.length === 0) {
            alert("Please select at least one building.");
            return;
        }
        if (emails.length === 0 && !selectedInspector1) {
            alert("Please select at least one inspector or enter an email");
            return;
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emails.some(email => !emailRegex.test(email))) {
            alert("Please provide valid email addresses.");
            return;
        }
        if (!user) return;

        const selectedBuildingDetails = latestReportsByBuilding.filter((building) =>
            selectedBuildings1.includes(building.uid)
        );
        const selectedBuildingNames = selectedBuildingDetails.map((building) => building.uid);

        setLoading(true);

        try {
            const pdfLinksByBuilding = await makePdfsForAllBuildings(user, selectedBuildingDetails);

            await saveSurveyRequestInfoToFirestore1(
                user,
                selectedBuildingNames,
                selectedInspector1,
                emails,
                pdfLinksByBuilding
            );

            toast.info('Survey maintenance saved successfully!', {
                toastId: 'survey_success',
                className: 'green-toast',
                icon: <FontAwesomeIcon icon={faCircleCheck} bounce size="sm" style={{ color: "green" }} />,
                progressClassName: 'green-progress-bar',
            });

            resetModalState();
        } catch (error) {
            console.error("Error saving survey request:", error);
            toast.error('Something went wrong saving the survey. Please try again.', {
                toastId: 'survey_error',
            });
        } finally {
            setLoading(false);
        }
    };

    const resetModalState = () => {
        setSelectedBuildings1([]);
        setSelectedBuildingsDoor([]);
        setSelectedInspector('');
        setInspectionDate('');
        setIsModalOpen1(false);
        setEmails([]);
        setDoorFilters([]);
        setSelectedData([]);
    };

    const makePdfsForAllBuildings = async (authUser, selectedBuildings) => {
        try {
            const pdfPromises = selectedBuildings.map(async (building) => {
                const buildingData = latestReportsByBuilding.find((b) => b.uid === building.uid);
                if (!buildingData) {
                    return { buildingId: building.uid, pdfLink: null };
                }

                const doors = selectedBuildingsDoor[building.uid] || [];
                try {
                    const pdfLink = await makePdf(authUser, buildingData, doors);
                    return { buildingId: building.uid, pdfLink };
                } catch (error) {
                    console.error(`Failed to generate PDF for building ${building.uid}:`, error);
                    return { buildingId: building.uid, pdfLink: null };
                }
            });

            const pdfResults = await Promise.all(pdfPromises);
            return pdfResults.reduce((acc, { buildingId, pdfLink }) => {
                acc[buildingId] = pdfLink;
                return acc;
            }, {});
        } catch (error) {
            console.error("Error generating PDFs for all buildings:", error);
            throw error;
        }
    };

    const saveSurveyRequestInfoToFirestore1 = async (authUser, selectedBuildingNames, selectedInspector, emails, pdfLinksByBuilding) => {
        try {
            if (authUser) {
                const userDocRef = doc(db, 'users', authUser.uid);
                const requestedSurveysRef = collection(userDocRef, 'requestedMaintainence');

                const surveyData = {
                    enteredEmails: emails,
                    requestedAt: new Date().toUTCString(),
                    ...(selectedInspector && {
                        selectedInspector: {
                            uid: selectedInspector.uid,
                            name: selectedInspector.name,
                            email: selectedInspector.email,
                        },
                    }),
                };

                const surveyDocRef = await addDoc(requestedSurveysRef, surveyData);

                const buildingPromises = selectedBuildingNames.map(async (buildingId) => {
                    const buildingData = latestReportsByBuilding.find((b) => b.uid === buildingId);
                    if (!buildingData) {
                        return;
                    }

                    const doors = selectedBuildingsDoor[buildingId] || [];
                    const pdfLink = pdfLinksByBuilding[buildingId] || "";

                    const buildingRef = doc(collection(surveyDocRef, 'selectedBuildings'), buildingId);
                    await setDoc(buildingRef, {
                        building_uid: buildingId,
                        selectedDoors: doors,
                        pdfLink,
                    });
                });

                await Promise.all(buildingPromises);
            }
        } catch (error) {
            console.error("Error saving survey request to Firestore:", error);
            throw error;
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <ClipLoader color="#b11111" size={60} />
                <div className="loading-text">
                    {displayedText}
                    <span className="cursor">|</span>
                </div>
            </div>
        );
    }

    const selectStyles = {
        control: (provided, { isFocused }) => ({
            ...provided,
            borderRadius: "0.375rem",
            padding: "0 0.5rem",
            borderColor: isFocused ? "#dc3545" : "#ced4da",
            boxShadow: isFocused ? "0 0 0 0.2rem rgba(220,53,69,.25)" : "none",
            minHeight: "38px",
            height: "38px",
            outline: "none",
            "&:hover": { borderColor: "#dc3545" },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: 'pointer',
        }),
        menu: (provided) => ({
            ...provided,
            width: "260px",
        }),
        option: (provided, { isFocused, isSelected }) => ({
            ...provided,
            backgroundColor: isSelected
                ? "#dc3545"
                : isFocused
                    ? "#ffe5e5"
                    : "white",
            color: isSelected ? "white" : "#333",
            cursor: "pointer",
            minHeight: "38px",
            display: "flex",
            alignItems: "center",
            "&:active": { backgroundColor: "#dc3545" },
        }),
        singleValue: provided => ({
            ...provided,
            color: "#282828ff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        placeholder: provided => ({
            ...provided,
            color: "#282828ff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        dropdownIndicator: provided => ({
            ...provided,
            color: "#a71d2a",
            "&:hover": { color: "#dc3545" },
        }),
        clearIndicator: provided => ({
            ...provided,
            color: "#a71d2a",
            "&:hover": { color: "#dc3545" },
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
    };


    return (
        <div className="safety-dashboard bg-light">

            <div className="bg-light safety-hero">
                <div className="container px-3 px-lg-4">
                    <div className="row align-items-center safety-hero-row">

                        <div className="col-12 col-md-3 col-lg-2 text-center text-md-start d-none d-md-flex safety-hero-logo-col">
                            <div className="justify-content-start">
                                <img
                                    src={logo}
                                    alt="logo"
                                    className="img-fluid logo-img"
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-9 col-lg-10">
                            <div className="ps-md-4 ps-lg-5 border-start border-3 border-danger content-section safety-hero-content">
                                <h1 className="h2 fw-bold text-dark safety-hero-title">
                                    Safety Dashboard
                                </h1>
                                <p className="text-secondary safety-hero-copy">
                                    Manage fire inspections, track compliance, and stay in control of your building portfolio.
                                </p>
                                <div className="d-flex flex-row gap-2 safety-hero-actions">
                                    {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'coordinator') && (
                                        <button
                                            className="btn btn-danger px-4 py-2 fw-semibold safety-primary-btn"
                                            onClick={() => {
                                                if (userData.role !== 'admin' && userData.role !== 'manager' && userData.role !== 'inspection' && userData.role !== 'coordinator') {
                                                    toast.info("You don't have admin privileges!", {
                                                        toastId: 'no_admin_privilege',
                                                        className: 'red-toast',
                                                        icon: <FontAwesomeIcon icon={faCircleXmark} size="lg" style={{ color: "red" }} />,
                                                        progressClassName: 'red-progress-bar',
                                                        style: {
                                                            backgroundColor: '#fee',
                                                            color: '#c00',
                                                            borderLeft: '4px solid red'
                                                        }
                                                    });
                                                    return;
                                                }

                                                setShowDetailsModal(true);
                                            }}
                                        >
                                            <i className="bi bi-clipboard-check me-2"></i>
                                            Request Inspection
                                        </button>
                                    )}

                                    <button
                                        className="btn btn-outline-danger px-4 py-2 fw-semibold safety-secondary-btn"
                                        onClick={() => goToReports('all')}>
                                        <i className="bi bi-graph-up me-2"></i>
                                        View Reports
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container px-3 px-lg-4 safety-dashboard-content">
                <div className="row g-2 g-md-3 safety-stats-row">
                    {stats.length === 0
                        ? Array(4).fill(null).map((_, index) => (
                            <div key={index} className="col-6 col-lg-3">
                                <div className="card h-100 safety-stat-card">
                                    <div className="card-body d-flex flex-column align-items-start justify-content-between safety-stat-body">
                                        <div className="safety-stat-icon mb-2">
                                            <Skeleton circle={true} height={26} width={26} />
                                        </div>
                                        <div className="mb-2" style={{ width: '80%' }}>
                                            <Skeleton height={12} />
                                        </div>
                                        <div className="mb-2" style={{ width: '60%' }}>
                                            <Skeleton height={28} />
                                        </div>
                                        <div style={{ width: '40%' }}>
                                            <Skeleton height={12} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        : stats.map((stat, index) => (
                            <div key={index} className="col-6 col-lg-3">
                                <div
                                    className="card h-100 safety-stat-card"
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-4px)';
                                        e.currentTarget.style.boxShadow = '0 0.5rem 1rem rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '';
                                    }}
                                    onClick={() => goToReports(stat.filter)}
                                >
                                    <div className="card-body d-flex flex-column align-items-start justify-content-between safety-stat-body">
                                        <div className={`text-${stat.color} safety-stat-icon mb-2`}>
                                            <FontAwesomeIcon icon={stat.icon} />
                                        </div>
                                        <p className="text-muted text-uppercase fw-semibold safety-stat-label">{stat.title}</p>
                                        <h2 className="fw-bold safety-stat-value">
                                            <AnimatedNumbers text={String(stat.value)} duration={3000} animKey={statsKey} />
                                        </h2>
                                        <p className="text-muted safety-stat-change">
                                            <AnimatedNumbers text={String(stat.change)} duration={3000} animKey={statsKey} />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className="safety-lower-section">
                    <div className="safety-quick-column">
                        <div className="safety-section-panel safety-quick-panel">
                            <h5 className="fw-bold safety-section-title">Quick Actions</h5>
                            <div className="safety-quick-grid">
                                {(loading ? Array(quickActions.length).fill(0) : quickActions).map((action, index) => (
                                    <div key={index} className="safety-quick-item">
                                        <div
                                            className="card h-100 w-100 safety-quick-card"
                                            style={{ transition: 'transform 0.2s', cursor: 'pointer' }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-4px)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                                            onClick={loading ? undefined : action.onClick}
                                        >
                                            <div className="card-body d-flex flex-column justify-content-between safety-quick-card-body">
                                                <div className="safety-action-icon mb-2">
                                                    {loading ? <Skeleton circle height={26} width={26} /> : (
                                                        <FontAwesomeIcon icon={action.icon} className={`text-${action.color}`} />
                                                    )}
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold safety-action-title">{loading ? <Skeleton height={16} width="70%" /> : action.title}</h6>
                                                    <p className="text-muted safety-action-copy">{loading ? <Skeleton height={12} width="90%" /> : action.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="safety-activity-column">
                        <div className="safety-section-panel safety-activity-panel">
                            <div className="d-flex align-items-center justify-content-between gap-2 safety-section-header">
                                <h5 className="fw-bold mb-0 safety-section-title">Recent Activity</h5>
                                <div className="safety-activity-search" style={{ position: 'relative', width: '220px' }}>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm safety-search-input"
                                        placeholder="Search building..."
                                        value={recentActivitySearch}
                                        onChange={e => handleRecentActivitySearch(e.target.value)}
                                        onFocus={e => {
                                            e.target.style.outline = 'none';
                                            e.target.style.boxShadow = '0 0 0 0.25rem rgba(220, 53, 69, 0.25)';
                                            e.target.style.borderColor = '#dc3545';
                                        }}
                                        onBlur={e => {
                                            e.target.style.boxShadow = '';
                                            e.target.style.borderColor = '';
                                            setTimeout(() => setRecentActivitySuggestions([]), 150);
                                        }}
                                        style={{ paddingRight: recentActivitySearch ? '28px' : '10px', fontSize: '0.85rem' }}
                                    />
                                    {recentActivitySearch && (
                                        <span
                                            onClick={() => {
                                                setRecentActivitySearch('');
                                                setRecentActivityVisible(20);
                                                setRecentActivitySuggestions([]);
                                            }}
                                            style={{
                                                position: 'absolute', right: '8px', top: '50%',
                                                transform: 'translateY(-50%)', cursor: 'pointer',
                                                color: '#6c757d', fontSize: '13px', zIndex: 1,
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTimes} />
                                        </span>
                                    )}

                                    {recentActivitySuggestions.length > 0 && (
                                        <div className="safety-search-suggestions" style={{
                                            position: 'absolute', top: '100%', left: 0, right: 0,
                                            zIndex: 9999, background: '#ffffff',
                                            border: '1px solid #dee2e6', borderRadius: '8px',
                                            marginTop: '4px', boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                            overflow: 'hidden',
                                        }}>
                                            {recentActivitySuggestions.map((name, i) => {
                                                const isLoaded = !!loadedDoors[name];
                                                const isLoading = !!doorsLoading[name];

                                                return (
                                                    <div
                                                        key={name}
                                                        onMouseDown={async () => {
                                                            setRecentActivitySearch(name);
                                                            setRecentActivitySuggestions([]);
                                                            setRecentActivityVisible(20);
                                                            await loadDoorsForBuilding(name);
                                                        }}
                                                        style={{
                                                            padding: '8px 12px', cursor: 'pointer', fontSize: '13px',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                            borderBottom: i < recentActivitySuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                            background: '#ffffff', transition: 'background 0.15s',
                                                        }}
                                                        onMouseEnter={e => e.currentTarget.style.background = '#fff5f5'}
                                                        onMouseLeave={e => e.currentTarget.style.background = '#ffffff'}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <FontAwesomeIcon icon={faBuilding} style={{ fontSize: '11px', color: '#adb5bd' }} />
                                                            <span style={{ color: '#212529' }}>{name}</span>
                                                        </div>

                                                        {isLoaded ? (
                                                            <span style={{ fontSize: '11px', color: '#10b981', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" />
                                                                    <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                                ready
                                                            </span>
                                                        ) : isLoading ? (
                                                            <span style={{ fontSize: '11px', color: '#f59e0b', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <span className="spinner-border spinner-border-sm" style={{ width: '10px', height: '10px', borderWidth: '1.5px' }} />
                                                                loading…
                                                            </span>
                                                        ) : (
                                                            <span style={{ fontSize: '11px', color: '#adb5bd', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M12 4v16m8-8H4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                                                                </svg>
                                                                tap to load
                                                            </span>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div
                                id="recentActivityContainer"
                                ref={recentActivityContainerRef}
                                className="card safety-activity-list"
                            >
                                {recentActivity.length === 0 ? (
                                    Array(3).fill(0).map((_, idx) => (
                                        <div key={idx} className="d-flex align-items-center border-bottom safety-activity-item">
                                            <Skeleton circle height={64} width={64} className="me-3" />
                                            <div className="flex-grow-1">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <Skeleton height={20} width="60%" />
                                                    <Skeleton height={20} width={60} />
                                                </div>
                                                <Skeleton height={12} width="40%" className="mb-2" />
                                                <div className="d-flex flex-wrap">
                                                    {Array(4).fill(0).map((__, i) => (
                                                        <div key={i} className="d-flex align-items-center me-3 mb-1">
                                                            <Skeleton circle height={23} width={23} className="me-2" />
                                                            <Skeleton height={12} width={25} />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : filteredActivity.length === 0 ? (
                                    <div className="p-4 text-center text-muted" style={{ fontSize: '0.9rem' }}>
                                        No buildings match "{recentActivitySearch}"
                                    </div>
                                ) : (
                                    visibleActivity.map((activity, index) => (
                                        <div
                                            key={index}
                                            className={`d-flex align-items-center safety-activity-item ${index !== visibleActivity.length - 1 ? 'border-bottom' : ''}`}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleReportClick(activity.buildingUID, activity, activity.redCount, activity.greenCount)}
                                        >
                                            <div className="flex-shrink-0 rounded overflow-hidden safety-activity-thumb">
                                                <img src={activity.image} alt={activity.building} className="img-fluid h-100 w-100 object-fit-cover" />
                                            </div>
                                            <div className="flex-grow-1 safety-activity-content">
                                                <div className="d-flex justify-content-between align-items-start gap-2">
                                                    <h6 className="mb-0 fw-bold safety-activity-name">{activity.building}</h6>
                                                    <span className={`badge bg-${activity.statusColor} text-uppercase safety-status-badge`}>
                                                        {activity.status}
                                                    </span>
                                                </div>
                                                <p className="text-muted small safety-activity-date">{activity.date}</p>
                                                <div className="d-flex align-items-center flex-wrap safety-door-counts">
                                                    {[
                                                        ['red', redDoor, activity.greenCount],
                                                        ['green', greenDoor, activity.redCount],
                                                        ['yellow', yellowDoor, activity.yellowCount],
                                                        ['grey', greyDoor, activity.greyCount],
                                                    ].map(([color, img, count], i) => (
                                                        <div key={i} className="d-flex align-items-center gap-1 safety-door-count">
                                                            <img src={img} alt={color} style={{ height: '23px', width: 'auto' }} />
                                                            <span className="fw-bold">
                                                                {loadedDoors[activity.building] ? count : (
                                                                    <span className="spinner-border spinner-border-sm" style={{ width: '10px', height: '10px', borderWidth: '1.5px' }} />
                                                                )}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                            <div className="safety-activity-meta">
                                <div className="safety-progress-track">
                                    <div
                                        className="safety-progress-fill"
                                        style={{
                                            width: `${filteredActivity.length > 0 ? (visibleActivity.length / filteredActivity.length) * 100 : 0}%`,
                                        }}
                                    />
                                </div>
                                <span className="safety-progress-count">
                                    <span>{visibleActivity.length}</span>
                                    {' '}of{' '}
                                    <span>{filteredActivity.length}</span>
                                    {' '}buildings
                                </span>
                            </div>

                            {hasMoreActivity && (
                                <div className="text-center safety-load-more-wrap">
                                    <button
                                        onClick={handleLoadMoreActivity}
                                        disabled={loadingMoreActivity}
                                        className={`btn ${loadingMoreActivity ? 'btn-outline-danger' : 'btn-danger'} px-4 safety-load-more-btn`}
                                        style={{ borderRadius: '12px', fontWeight: '500', fontSize: '0.85rem' }}
                                    >
                                        {loadingMoreActivity ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" style={{ width: '14px', height: '14px' }} />
                                                Loading {Math.min(20, filteredActivity.length - recentActivityVisible)} buildings…
                                            </>
                                        ) : (
                                            <>
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="me-2">
                                                    <path d="M12 5v14m7-7H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                                Load {Math.min(20, filteredActivity.length - recentActivityVisible)} more buildings
                                            </>
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer autoClose={1000} />


            <Modal
                isOpen={isModalOpen1}
                onRequestClose={() => setIsModalOpen1(false)}
                contentLabel="Survey Modal 2"
                className={`custom-modal ${isModalOpen1 ? 'modal-open' : 'modal-closed'}`}
                overlayClassName={`custom-overlay ${isModalOpen1 ? 'overlay-open' : 'overlay-closed'}`}
                closeTimeoutMS={300}
                style={{
                    overlay: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                    content: {
                        position: 'relative',
                        background: 'white',
                        borderRadius: '15px',
                        width: '90%',
                        maxWidth: '1200px',
                        maxHeight: '90vh',
                        overflow: 'hidden',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
                        border: 'none',
                        padding: 0,
                    }
                }}
            >
                <div style={{
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '15px',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        top: 0,
                        zIndex: 1000,
                        backgroundColor: '#fff',
                        borderBottom: '2px solid #e0e0e0',
                        padding: '20px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                    }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>
                                {currentStep1 === 1 && "Select Buildings"}
                                {currentStep1 === 2 && "Select Doors"}
                                {currentStep1 === 3 && "Select Inspector"}
                                {currentStep1 === 4 && "Inspection Date"}
                            </h3>
                            <div className="d-flex gap-2">
                                {currentStep1 > 1 && (
                                    <button className="btn btn-secondary" onClick={handleBackStep1}>Back</button>
                                )}
                                {currentStep1 === 1 && (
                                    <button className="btn btn-success" onClick={handleNextStep1} disabled={selectedBuildings1.length === 0}>Next</button>
                                )}
                                {currentStep1 === 2 && (
                                    <button className="btn btn-success" onClick={handleNextStep1}
                                        disabled={selectedBuildings1.length === 0 || selectedBuildings1.some((buildingId) => !selectedBuildingsDoor[buildingId] || selectedBuildingsDoor[buildingId].length === 0)}>
                                        Next
                                    </button>
                                )}
                                {currentStep1 === 3 && (
                                    <button className="btn btn-primary" onClick={handleModalSubmit1}>Submit</button>
                                )}
                                <button className="btn btn-danger" onClick={() => setIsModalOpen1(false)}>Cancel</button>
                            </div>
                        </div>
                    </div>

                    <div style={{ overflowY: 'auto', padding: '20px', flex: 1 }}>

                        {currentStep1 === 1 && (
                            <>
                                <div className="mb-4">
                                    <div className="input-group">
                                        <span className="input-group-text" style={{
                                            backgroundColor: '#fff',
                                            border: '2px solid #333',
                                            borderRight: 'none',
                                            borderRadius: '25px 0 0 25px',
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg>
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search buildings..."
                                            value={buildingSearchTerm}
                                            onChange={(e) => setBuildingSearchTerm(e.target.value)}
                                            style={{
                                                padding: '12px 20px',
                                                border: '2px solid #333',
                                                borderLeft: 'none',
                                                fontSize: '16px',
                                                borderRadius: '0 25px 25px 0',
                                                outline: 'none',
                                                boxShadow: 'none'
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {latestReportsByBuilding
                                        .filter((building) => building.buildingName.toLowerCase().includes(buildingSearchTerm.toLowerCase()))
                                        .map((building) => (
                                            <div className={`${isMobile ? 'col-6' : 'col-lg-3 col-md-6 col-12'} mb-4`} key={building.uid}>
                                                <div
                                                    className={`card serviceCard ${selectedBuildings1.includes(building.uid) ? 'selected' : ''}`}
                                                    onClick={() => handleBuildingSelection1(building.uid, building)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        borderRadius: '15px',
                                                        overflow: 'hidden',
                                                        border: selectedBuildings1.includes(building.uid) ? '2px solid #28a745' : '2px solid transparent',
                                                        boxShadow: selectedBuildings1.includes(building.uid) ? '0 0 0 3px #28a745, 0 8px 25px rgba(40, 167, 69, 0.3)' : '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                >
                                                    {selectedBuildings1.includes(building.uid) && (
                                                        <div className="position-absolute top-0 end-0 m-2" style={{ zIndex: 10 }}>
                                                            <span className="badge bg-success rounded-circle p-2">✓</span>
                                                        </div>
                                                    )}
                                                    <img src={building.buildingLink} alt={building.buildingName} style={{ height: isMobile ? '150px' : '200px', objectFit: 'cover', width: '100%' }} />
                                                    <div className="card-body text-center">
                                                        <h6 style={{ fontWeight: '600', margin: '0 0 5px 0' }}>{building.buildingName}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </>
                        )}

                        {currentStep1 === 2 && (
                            <div>
                                <div style={{
                                    top: '85px',
                                    zIndex: 999,
                                    backgroundColor: '#fff',
                                    paddingBottom: '15px',
                                    marginBottom: '20px',
                                    borderBottom: '1px solid #e0e0e0'
                                }}>
                                    <div style={{ display: 'flex', gap: '5px', marginBottom: '15px', overflowX: 'auto', flexWrap: 'nowrap' }}>
                                        {selectedBuildings1.map((buildingId, index) => {
                                            const building = latestReportsByBuilding.find((b) => b.uid === buildingId);
                                            if (!building) return null;
                                            const isActive = !activeBuildingTab ? index === 0 : activeBuildingTab === buildingId;

                                            return (
                                                <button
                                                    key={buildingId}
                                                    onClick={() => {
                                                        setActiveBuildingTab(buildingId);
                                                        if (!doorTabKey[buildingId]) {
                                                            setDoorTabKey(prev => ({ ...prev, [buildingId]: 'communal' }));
                                                        }
                                                    }}
                                                    style={{
                                                        backgroundColor: isActive ? '#2196F3' : '#f8f9fa',
                                                        color: isActive ? 'white' : '#333',
                                                        borderRadius: '8px 8px 0 0',
                                                        padding: '10px 20px',
                                                        fontWeight: '600',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        whiteSpace: 'nowrap',
                                                        flexShrink: 0,
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    {building.buildingName}
                                                </button>
                                            );
                                        })}
                                    </div>

                                    {selectedBuildings1.map((buildingId, index) => {
                                        const isActive = !activeBuildingTab ? index === 0 : activeBuildingTab === buildingId;
                                        if (!isActive) return null;

                                        const currentDoorTab = doorTabKey[buildingId] || 'communal';
                                        const doorSearch = currentDoorTab === 'communal' ? doorSearchTerms[buildingId] || '' : resiDoorSearchTerms[buildingId] || '';

                                        return (
                                            <div key={`controls-${buildingId}`}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                                                    <div style={{ display: 'flex', gap: '10px' }}>
                                                        <button
                                                            onClick={() => setDoorTabKey(prev => ({ ...prev, [buildingId]: 'communal' }))}
                                                            style={{
                                                                backgroundColor: currentDoorTab === 'communal' ? '#dc3545' : '#f8f9fa',
                                                                color: currentDoorTab === 'communal' ? 'white' : '#333',
                                                                borderRadius: '20px',
                                                                padding: '8px 20px',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                fontWeight: '500',
                                                                fontSize: '14px'
                                                            }}
                                                        >
                                                            Communal Doors
                                                        </button>
                                                        <button
                                                            onClick={() => setDoorTabKey(prev => ({ ...prev, [buildingId]: 'residential' }))}
                                                            style={{
                                                                backgroundColor: currentDoorTab === 'residential' ? '#dc3545' : '#f8f9fa',
                                                                color: currentDoorTab === 'residential' ? 'white' : '#333',
                                                                borderRadius: '20px',
                                                                padding: '8px 20px',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                fontWeight: '500',
                                                                fontSize: '14px'
                                                            }}
                                                        >
                                                            Residential Doors
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="input-group" style={{ paddingTop: '20px' }}>
                                                    <span className="input-group-text" style={{
                                                        backgroundColor: '#fff',
                                                        border: '2px solid #333',
                                                        borderRight: 'none',
                                                        borderRadius: '25px 0 0 25px',
                                                    }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" viewBox="0 0 16 16">
                                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                                        </svg>
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search doors..."
                                                        value={currentDoorTab === 'communal' ? doorSearchTerms[buildingId] || '' : resiDoorSearchTerms[buildingId] || ''}
                                                        onChange={(e) => {
                                                            if (currentDoorTab === 'communal') {
                                                                handleDoorSearchChange(buildingId, e.target.value);
                                                            } else {
                                                                handleResiDoorSearchChange(buildingId, e.target.value);
                                                            }
                                                        }}
                                                        style={{
                                                            padding: '12px 20px',
                                                            border: '2px solid #333',
                                                            borderLeft: 'none',
                                                            fontSize: '16px',
                                                            borderRadius: '0 25px 25px 0',
                                                            outline: 'none',
                                                            boxShadow: 'none'
                                                        }}
                                                    />
                                                </div>

                                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px', marginTop: '10px' }}>
                                                    {currentDoorTab === 'communal' ? (
                                                        <>
                                                            <button className={`btn btn-sm ${(doorFilters[buildingId] || 'All') === 'All' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                                onClick={() => handleBuildingFilterChange(buildingId, 'All')}>All</button>
                                                            <button className={`btn btn-sm ${(doorFilters[buildingId] || 'All') === 'Passed' ? 'btn-success' : 'btn-outline-success'}`}
                                                                onClick={() => handleBuildingFilterChange(buildingId, 'Passed')}>Passed</button>
                                                            <button className={`btn btn-sm ${(doorFilters[buildingId] || 'All') === 'Failed' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                onClick={() => handleBuildingFilterChange(buildingId, 'Failed')}>Failed</button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button className={`btn btn-sm ${(resiDoorFilters[buildingId] || 'All') === 'All' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                                onClick={() => handleBuildingFilterChange1(buildingId, 'All')}>All</button>
                                                            <button className={`btn btn-sm ${(resiDoorFilters[buildingId] || 'All') === 'Passed' ? 'btn-success' : 'btn-outline-success'}`}
                                                                onClick={() => handleBuildingFilterChange1(buildingId, 'Passed')}>Passed</button>
                                                            <button className={`btn btn-sm ${(resiDoorFilters[buildingId] || 'All') === 'Failed' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                onClick={() => handleBuildingFilterChange1(buildingId, 'Failed')}>Failed</button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {selectedBuildings1.map((buildingId, index) => {
                                    const building = latestReportsByBuilding.find((b) => b.uid === buildingId);
                                    if (!building) return null;

                                    const isBuildingActive = !activeBuildingTab ? index === 0 : activeBuildingTab === buildingId;
                                    if (!isBuildingActive) return null;

                                    const isLoadingDoors = doorsLoading[building.buildingName];
                                    const doors = loadedDoors[building.buildingName]?.doorReports || [];
                                    const resi_doors = loadedDoors[building.buildingName]?.resiReports || [];
                                    const currentDoorTab = doorTabKey[buildingId] || 'communal';

                                    const doorfilter = doorFilters[buildingId] || 'All';
                                    const doorSearch = doorSearchTerms[buildingId] || '';

                                    const sortedDoors = [...doors].sort(naturalDoorSort);
                                    const doorsWithOriginalIndex = sortedDoors.map((door, idx) => ({ ...door, originalIndex: idx, type: 'communal' }));

                                    const filteredDoors = doorsWithOriginalIndex.filter((door) => {
                                        let trueCount = 0;
                                        let falseCount = 0;
                                        const d1 = parseFloat(door.fD1) || 0;
                                        const d2 = parseFloat(door.fD2) || 0;
                                        const d3 = parseFloat(door.fD3) || 0;
                                        const d4 = parseFloat(door.fD4) || 0;
                                        const condition1 = (d1 <= 4 && d2 <= 4 && d3 <= 4);
                                        const condition2 = (d4 <= 8);

                                        if (door.doorCloseAsIntented === false) falseCount++;
                                        else trueCount++;
                                        if (door.hasOwnProperty('doorStrips')) { door.doorStrips ? trueCount++ : falseCount++; }
                                        door.hingesWorking ? trueCount++ : falseCount++;
                                        door.hingesFireRating ? trueCount++ : falseCount++;

                                        const damageMultiples = (door.damageMultiples || []).map(item => item.toString());
                                        if (damageMultiples.includes('None') && damageMultiples.length === 1) {
                                            trueCount++;
                                        } else {
                                            const isValidCondition = (damageMultiples.includes('Door Pass') || !damageMultiples.includes('Door')) &&
                                                (damageMultiples.includes('Frame Pass') || !damageMultiples.includes('Frame')) &&
                                                (damageMultiples.includes('Glass None') || damageMultiples.includes('Glass Pass') || !damageMultiples.includes('Glass')) &&
                                                (damageMultiples.includes('Ventilation Gaps None') || damageMultiples.includes('Ventilation Gaps Pass') || !damageMultiples.includes('Ventilation Gaps'));
                                            isValidCondition ? trueCount++ : falseCount++;
                                        }

                                        const doorCertif = door.doorCertif || '';
                                        (doorCertif && !doorCertif.includes('No')) ? trueCount++ : falseCount++;
                                        (condition1 && condition2) ? trueCount++ : falseCount++;

                                        const doorStatus = falseCount >= 1 ? 'Failed' : 'Passed';
                                        if (doorfilter === 'Passed' && doorStatus !== 'Passed') return false;
                                        if (doorfilter === 'Failed' && doorStatus !== 'Failed') return false;
                                        return true;
                                    });

                                    const searchedDoors = filteredDoors.filter((door) => {
                                        const term = doorSearch.toLowerCase();
                                        if (!term) return true;
                                        const doorLabel = (door.doorNumber || `C${door.originalIndex + 1}`).toString().toLowerCase();
                                        const location = (door.doorLocation || '').toLowerCase();
                                        const level = (door.doorLevel || '').toLowerCase();
                                        return doorLabel.includes(term) || location.includes(term) || level.includes(term);
                                    });

                                    const resi_doorfilter = resiDoorFilters[buildingId] || 'All';
                                    const resiDoorSearch = resiDoorSearchTerms[buildingId] || '';

                                    const resi_sortedDoors = [...resi_doors].sort(naturalDoorSort);
                                    const resi_doorsWithOriginalIndex = resi_sortedDoors.map((door, idx) => ({ ...door, originalIndex: idx, type: 'residential' }));

                                    const resi_filteredDoors = resi_doorsWithOriginalIndex.filter((door) => {
                                        let trueCount = 0;
                                        let falseCount = 0;
                                        const d1 = parseFloat(door.fD1) || 0;
                                        const d2 = parseFloat(door.fD2) || 0;
                                        const d3 = parseFloat(door.fD3) || 0;
                                        const d4 = parseFloat(door.fD4) || 0;
                                        const condition1 = (d1 <= 4 && d2 <= 4 && d3 <= 4);
                                        const condition2 = (d4 <= 8);

                                        if (door.doorCloseAsIntented === false) falseCount++;
                                        else trueCount++;
                                        if (door.hasOwnProperty('doorStrips')) { door.doorStrips ? trueCount++ : falseCount++; }
                                        door.hingesWorking ? trueCount++ : falseCount++;
                                        door.hingesFireRating ? trueCount++ : falseCount++;

                                        const damageMultiples = (door.damageMultiples || []).map(item => item.toString());
                                        if (damageMultiples.includes('None') && damageMultiples.length === 1) {
                                            trueCount++;
                                        } else {
                                            const isValidCondition = (damageMultiples.includes('Door Pass') || !damageMultiples.includes('Door')) &&
                                                (damageMultiples.includes('Frame Pass') || !damageMultiples.includes('Frame')) &&
                                                (damageMultiples.includes('Glass None') || damageMultiples.includes('Glass Pass') || !damageMultiples.includes('Glass')) &&
                                                (damageMultiples.includes('Ventilation Gaps None') || damageMultiples.includes('Ventilation Gaps Pass') || !damageMultiples.includes('Ventilation Gaps'));
                                            isValidCondition ? trueCount++ : falseCount++;
                                        }

                                        const doorCertif = door.doorCertif || '';
                                        (doorCertif && !doorCertif.includes('No')) ? trueCount++ : falseCount++;
                                        (condition1 && condition2) ? trueCount++ : falseCount++;

                                        const resi_doorStatus = falseCount >= 1 ? 'Failed' : 'Passed';
                                        if (resi_doorfilter === 'Passed' && resi_doorStatus !== 'Passed') return false;
                                        if (resi_doorfilter === 'Failed' && resi_doorStatus !== 'Failed') return false;
                                        return true;
                                    });

                                    const resi_searchedDoors = resi_filteredDoors.filter((door) => {
                                        const term = resiDoorSearch.toLowerCase();
                                        if (!term) return true;
                                        const doorLabel = (door.doorNumber || `R${door.originalIndex + 1}`).toString().toLowerCase();
                                        const location = (door.doorLocation || '').toLowerCase();
                                        const level = (door.doorLevel || '').toLowerCase();
                                        return doorLabel.includes(term) || location.includes(term) || level.includes(term);
                                    });

                                    if (isLoadingDoors) {
                                        return (
                                            <div key={`loading-${buildingId}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                                                <div className="text-center">
                                                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <p className="mt-3">Loading doors for {building.buildingName}...</p>
                                                </div>
                                            </div>
                                        );
                                    }

                                    return (
                                        <div key={`building-content-${buildingId}`}>
                                            {currentDoorTab === 'communal' && (
                                                <div className="row">
                                                    {searchedDoors.length > 0 ? (
                                                        searchedDoors.map((door) => (
                                                            <div className={`${isMobile ? 'col-6' : 'col-lg-3 col-md-6 col-12'} mb-4`} key={`communal-${door.uid}`}>
                                                                <div
                                                                    className={`card serviceCard ${selectedBuildingsDoor[buildingId]?.includes(door.uid) ? 'selected' : ''}`}
                                                                    onClick={() => handleDoorSelection1(door.uid, buildingId, door)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        borderRadius: '15px',
                                                                        overflow: 'hidden',
                                                                        border: selectedBuildingsDoor[buildingId]?.includes(door.uid) ? '2px solid #28a745' : '2px solid transparent',
                                                                        boxShadow: selectedBuildingsDoor[buildingId]?.includes(door.uid) ? '0 0 0 3px #28a745, 0 8px 25px rgba(40, 167, 69, 0.3)' : '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                                        transition: 'all 0.3s ease',
                                                                    }}
                                                                >
                                                                    {selectedBuildingsDoor[buildingId]?.includes(door.uid) && (
                                                                        <div className="position-absolute top-0 end-0 m-2" style={{ zIndex: 10 }}>
                                                                            <span className="badge bg-success rounded-circle p-2">✓</span>
                                                                        </div>
                                                                    )}
                                                                    <img src={door.doorPullPhotoLink || '/placeholder.jpg'} alt={door.doorLocation || 'Door'}
                                                                        style={{ height: isMobile ? '150px' : '200px', objectFit: 'cover', width: '100%' }} />
                                                                    <div className="card-body text-center">
                                                                        <h6 style={{ fontWeight: '600', margin: '0 0 5px 0' }}>
                                                                            C{door.doorNumber || door.originalIndex + 1}
                                                                        </h6>
                                                                        <p className="text-muted" style={{ fontSize: '0.875rem', margin: 0 }}>
                                                                            Level: {door.doorLevel || 'N/A'}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-12 text-center py-5">
                                                            <p className="text-muted">No communal doors found</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {currentDoorTab === 'residential' && (
                                                <div className="row">
                                                    {resi_searchedDoors.length > 0 ? (
                                                        resi_searchedDoors.map((door) => (
                                                            <div className={`${isMobile ? 'col-6' : 'col-lg-3 col-md-6 col-12'} mb-4`} key={`residential-${door.uid}`}>
                                                                <div
                                                                    className={`card serviceCard ${selectedBuildingsDoor[buildingId]?.includes(door.uid) ? 'selected' : ''}`}
                                                                    onClick={() => handleDoorSelection1(door.uid, buildingId, door)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        borderRadius: '15px',
                                                                        overflow: 'hidden',
                                                                        border: selectedBuildingsDoor[buildingId]?.includes(door.uid) ? '2px solid #28a745' : '2px solid transparent',
                                                                        boxShadow: selectedBuildingsDoor[buildingId]?.includes(door.uid) ? '0 0 0 3px #28a745, 0 8px 25px rgba(40, 167, 69, 0.3)' : '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                                        transition: 'all 0.3s ease',
                                                                    }}
                                                                >
                                                                    {selectedBuildingsDoor[buildingId]?.includes(door.uid) && (
                                                                        <div className="position-absolute top-0 end-0 m-2" style={{ zIndex: 10 }}>
                                                                            <span className="badge bg-success rounded-circle p-2">✓</span>
                                                                        </div>
                                                                    )}
                                                                    <img src={door.doorPullPhotoLink || '/placeholder.jpg'} alt={door.doorLocation || 'Door'}
                                                                        style={{ height: isMobile ? '150px' : '200px', objectFit: 'cover', width: '100%' }} />
                                                                    <div className="card-body text-center">
                                                                        <h6 style={{ fontWeight: '600', margin: '0 0 5px 0' }}>
                                                                            R{door.doorNumber || door.originalIndex + 1}
                                                                        </h6>
                                                                        <p className="text-muted" style={{ fontSize: '0.875rem', margin: 0 }}>
                                                                            Level: {door.doorLevel || 'N/A'}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-12 text-center py-5">
                                                            <p className="text-muted">No residential doors found</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {currentStep1 === 3 && (
                            <div>
                                {inspectorInfos.length === 0 ? (
                                    <p>No inspectors available</p>
                                ) : (
                                    <div className="row">
                                        {inspectorInfos.map((inspector) => (
                                            <div className={`${isMobile ? 'col-6' : 'col-lg-3 col-md-4 col-6'} mb-4`} key={inspector.uid}>
                                                <div
                                                    className={`card ${selectedInspector1?.uid === inspector.uid ? 'selected' : ''}`}
                                                    onClick={() => handleInspectorSelection1(inspector)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        borderRadius: '15px',
                                                        overflow: 'hidden',
                                                        border: selectedInspector1?.uid === inspector.uid ? '2px solid #28a745' : '2px solid transparent',
                                                        boxShadow: selectedInspector1?.uid === inspector.uid ? '0 0 0 3px #28a745, 0 8px 25px rgba(40, 167, 69, 0.3)' : '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                >
                                                    {selectedInspector1?.uid === inspector.uid && (
                                                        <div className="position-absolute top-0 end-0 m-2" style={{ zIndex: 10 }}>
                                                            <span className="badge bg-success rounded-circle p-2">✓</span>
                                                        </div>
                                                    )}
                                                    <div className="text-center p-3">
                                                        <img src={inspector.photoURL || logo} alt={inspector.name}
                                                            style={{ width: '120px', height: '120px', objectFit: 'contain', marginBottom: '10px' }} />
                                                        <p className="fw-bold mb-1">Firechecked Expert</p>
                                                        <p className="text-muted" style={{ fontSize: '0.875rem', wordBreak: 'break-word' }}>{inspector.email}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="mt-4">
                                    <label className="form-label fw-bold">Enter Email:</label>
                                    <div className="d-flex gap-2 mb-3" style={{ maxWidth: '500px' }}>
                                        <input type="email" id="email" className="form-control" placeholder="Enter email address"
                                            onKeyDown={(e) => { if (e.key === 'Enter') { addEmail(e.target.value); e.target.value = ''; e.preventDefault(); } }} />
                                        <button className="btn btn-success" onClick={() => { const input = document.getElementById('email'); addEmail(input.value); input.value = ''; }}>Add</button>
                                    </div>
                                    {emails.length > 0 && (
                                        <div className="card" style={{ maxWidth: '500px' }}>
                                            <div className="card-body">
                                                <h5 className="card-title">Added Emails:</h5>
                                                <ul className="list-group">
                                                    {emails.map((email, index) => (
                                                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {email}
                                                            <button className="btn btn-danger btn-sm" onClick={() => removeEmail(index)}>Remove</button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>


            <ContactModal
                show={showInviteModal}
                onClose={() => setShowInviteModal(false)}
            />


            <InspectionModal
                directOpen={showDetailsModal}
                onDirectClose={() => setShowDetailsModal(false)}
                inspectores={inspectores}
                visibleTabs={['section1', 'section2', 'section3']}
                onSaved={fetchData}
                onScheduled={fetchData}
            />

            <BootstrapModal
                className="details-modal"
                show={isBookingModalOpen}
                onHide={() => {
                    setIsBookingModalOpen1(false);
                    resetRequestForm();
                }}
                centered={!isMobile}
                backdrop="static"
                keyboard={false}
                scrollable
                style={{ '--bs-modal-width': '760px' }}
            >
                <BootstrapModal.Header closeButton >
                    <BootstrapModal.Title>Inspection Request Details</BootstrapModal.Title>
                </BootstrapModal.Header>

                <BootstrapModal.Body>
                    <Form ref={formRef} onSubmit={handleRequestSubmit}>

                        <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">REQUESTING PARTY</small>
                        </div>
                        <Row>
                            <Col md={3}>
                                <Form.Group controlId="companyName" className="mb-3">
                                    <Form.Label>Company Name *</Form.Label>
                                    <Form.Control
                                        name="companyName"
                                        type="text"
                                        placeholder="Enter Company Name"
                                        value={requestFormData.companyName}
                                        onChange={e => handleRequestFieldChange('companyName', e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="propertyManagerEmail" className="mb-3">
                                    <Form.Label>Property Manager Email *</Form.Label>
                                    <Form.Control
                                        name="propertyManagerEmail"
                                        type="email"
                                        placeholder="Enter Email"
                                        value={requestFormData.propertyManagerEmail}
                                        onChange={e => handleRequestFieldChange('propertyManagerEmail', e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="propertyAddress" className="mb-3">
                                    <Form.Label>Property Address *</Form.Label>
                                    <Form.Control
                                        name="propertyAddress"
                                        type="text"
                                        placeholder="Enter Property Address"
                                        value={requestFormData.propertyAddress}
                                        onChange={e => handleRequestFieldChange('propertyAddress', e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">BUILDING DETAILS</small>
                        </div>
                        <Row>
                            <Col md={3}>
                                <Form.Group controlId="totalCommunalDoors" className="mb-3">
                                    <Form.Label>Communal Doors</Form.Label>
                                    <Form.Control
                                        name="totalCommunalDoors"
                                        type="number"
                                        placeholder="0"
                                        value={requestFormData.totalCommunalDoors}
                                        onChange={e => handleRequestFieldChange('totalCommunalDoors', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="totalResiDoors" className="mb-3">
                                    <Form.Label>Residential Doors</Form.Label>
                                    <Form.Control
                                        name="totalResiDoors"
                                        type="number"
                                        placeholder="0"
                                        value={requestFormData.totalResiDoors}
                                        onChange={e => handleRequestFieldChange('totalResiDoors', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="buildingHeight" className="mb-3">
                                    <Form.Label>Height (floors)</Form.Label>
                                    <Form.Control
                                        name="buildingHeight"
                                        type="number"
                                        placeholder="0"
                                        value={requestFormData.buildingHeight}
                                        onChange={e => handleRequestFieldChange('buildingHeight', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="fireRiskAssessment" className="mb-3">
                                    <Form.Label>Fire Risk Assessment</Form.Label>
                                    <Form.Control
                                        name="fireRiskAssessment"
                                        type="file"
                                        accept=".pdf,.doc,.docx"
                                        onChange={handleRequestFileChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">PAYEE DETAILS FOR INVOICE</small>
                        </div>
                        <Row>
                            <Col md={3}>
                                <Form.Group controlId="payeeName" className="mb-3">
                                    <Form.Label>Payee Name</Form.Label>
                                    <Form.Control
                                        name="payeeName"
                                        type="text"
                                        placeholder="Enter Name"
                                        value={requestFormData.payeeName}
                                        onChange={e => handleRequestFieldChange('payeeName', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="payeeAddress" className="mb-3">
                                    <Form.Label>Payee Address</Form.Label>
                                    <Form.Control
                                        name="payeeAddress"
                                        type="text"
                                        placeholder="Enter Address"
                                        value={requestFormData.payeeAddress}
                                        onChange={e => handleRequestFieldChange('payeeAddress', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="payeeEmail" className="mb-3">
                                    <Form.Label>Payee Email</Form.Label>
                                    <Form.Control
                                        name="payeeEmail"
                                        type="email"
                                        placeholder="Enter Email"
                                        value={requestFormData.payeeEmail}
                                        onChange={e => handleRequestFieldChange('payeeEmail', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="payeePhone" className="mb-3">
                                    <Form.Label>Payee Phone</Form.Label>
                                    <Form.Control
                                        name="payeePhone"
                                        type="tel"
                                        placeholder="Enter Phone"
                                        value={requestFormData.payeePhone}
                                        onChange={e => handleRequestFieldChange('payeePhone', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="payeeContactDetails" className="mb-3">
                                    <Form.Label>Contact Details</Form.Label>
                                    <Form.Control
                                        name="payeeContactDetails"
                                        type="text"
                                        placeholder="Additional contact details"
                                        value={requestFormData.payeeContactDetails}
                                        onChange={e => handleRequestFieldChange('payeeContactDetails', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">INSPECTION PREFERENCES</small>
                        </div>
                        <Row>
                            <Col md={3}>
                                <Form.Group controlId="frequency" className="mb-3">
                                    <Form.Label>Frequency of Inspection</Form.Label>
                                    <Form.Select
                                        name="frequency"
                                        value={requestFormData.frequency}
                                        onChange={e => handleRequestFieldChange('frequency', e.target.value)}
                                        styles={selectStyles}
                                    >
                                        <option value="Yearly">Yearly</option>
                                        <option value="Every 6 months">Every 6 months</option>
                                        <option value="Every 3 months">Every 3 months</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="contactResidents" className="mb-3">
                                    <Form.Label>Contact Residents?</Form.Label>
                                    <Form.Select
                                        name="contactResidents"
                                        value={requestFormData.contactResidents}
                                        onChange={e => handleRequestFieldChange('contactResidents', e.target.value)}
                                        styles={selectStyles}
                                    >
                                        <option value="">Select...</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group controlId="onsiteParking" className="mb-3">
                                    <Form.Label>Onsite Parking?</Form.Label>
                                    <Form.Select
                                        name="onsiteParking"
                                        value={requestFormData.onsiteParking}
                                        onChange={e => handleRequestFieldChange('onsiteParking', e.target.value)}
                                        styles={selectStyles}
                                    >
                                        <option value="">Select...</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            {requestFormData.onsiteParking === "Yes" && (
                                <Col md={3}>
                                    <Form.Group controlId="onsiteParkingDetails" className="mb-3">
                                        <Form.Label>Parking Details</Form.Label>
                                        <Form.Control
                                            name="onsiteParkingDetails"
                                            type="text"
                                            placeholder="Enter Parking Details"
                                            value={requestFormData.onsiteParkingDetails}
                                            onChange={e => handleRequestFieldChange('onsiteParkingDetails', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Form.Group controlId="accessDetails" className="mb-3">
                                    <Form.Label>Access Details (concierge/building manager contact, key safe or door code)</Form.Label>
                                    <Form.Control
                                        name="accessDetails"
                                        as="textarea"
                                        rows={3}
                                        style={{
                                            height: "150px",
                                            resize: "none",
                                        }}
                                        value={requestFormData.accessDetails}
                                        onChange={e => handleRequestFieldChange('accessDetails', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-end gap-2 mt-2 pt-3 border-top">
                            <Button
                                variant="light"
                                className="border"
                                onClick={() => {
                                    setIsBookingModalOpen1(false);
                                    resetRequestForm();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button variant="danger" type="submit">
                                Submit Request
                            </Button>
                        </div>
                    </Form>
                </BootstrapModal.Body>
            </BootstrapModal>

        </div >


    );
};

export default NewBuilding;